const CONFIG_TAB_ICONS = {
  bed: '<svg viewBox="0 0 24 24" style="width:18px;height:18px;fill:none;stroke:currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M3 18v-6a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v6"/><path d="M3 14h18"/><path d="M3 18h18"/><path d="M3 18v2M21 18v2"/><path d="M6.5 14v-1.2a1 1 0 0 1 1-1h2.5a1 1 0 0 1 1 1V14"/></svg>',
  swatch: '<svg viewBox="0 0 24 24" style="width:18px;height:18px;fill:none;stroke:currentColor" stroke-width="1.6" aria-hidden="true" focusable="false"><circle cx="12" cy="12" r="9"/><circle cx="12" cy="7.6" r="1.4" fill="currentColor" stroke="none"/><circle cx="16" cy="10.6" r="1.4" fill="currentColor" stroke="none"/><circle cx="14.4" cy="15.2" r="1.4" fill="currentColor" stroke="none"/><circle cx="9.6" cy="15.2" r="1.4" fill="currentColor" stroke="none"/><circle cx="8" cy="10.6" r="1.4" fill="currentColor" stroke="none"/></svg>',
  headboard: '<svg viewBox="0 0 39 31" style="width:20px;height:18px;fill:none;stroke:currentColor" aria-hidden="true" focusable="false"><path d="M38.2918 7.15958V7.15431L38.2916 7.14457C38.2915 7.13706 38.2913 7.12752 38.2909 7.11606C38.2902 7.09317 38.2888 7.06254 38.2862 7.02511C38.2811 6.95037 38.2712 6.84769 38.2519 6.7246C38.2136 6.47976 38.1373 6.14602 37.9833 5.78796C37.6686 5.0559 37.0357 4.24444 35.8248 3.89318C34.6002 3.53794 33.613 3.94519 32.9548 4.42333C32.7211 4.59312 32.5263 4.7731 32.3724 4.93418C32.2627 4.82649 32.133 4.70399 31.9828 4.56996C31.4324 4.07853 30.6077 3.43138 29.4958 2.78984C27.2691 1.50505 23.8998 0.248556 19.2923 0.301611C14.6909 0.354595 11.426 1.60987 9.29991 2.87101C8.23837 3.50066 7.464 4.1298 6.95078 4.60706C6.81475 4.73356 6.69705 4.8494 6.5972 4.95176C6.44386 4.80912 6.25199 4.64973 6.02409 4.49662C5.37661 4.06162 4.41808 3.66569 3.23458 3.88068C1.82604 4.13656 1.06636 4.92748 0.680039 5.69949C0.49293 6.07339 0.400053 6.42843 0.353516 6.69051C0.330127 6.82223 0.31805 6.93268 0.311796 7.01334C0.308663 7.05375 0.306974 7.08692 0.306067 7.1118C0.305613 7.12425 0.305354 7.13466 0.305208 7.14288L0.305065 7.15358L0.305038 7.15769L0.305032 7.15942L0.30503 7.16094V30.5344M38.2918 7.16094V30.5344H0.30503M0.30503 30.5344L0.305217 8.38651L0.305377 8.38103C0.305667 8.37301 0.306377 8.35779 0.308047 8.33631C0.311387 8.29318 0.290244 8.22724 0.305244 8.14276M0.30503 30.5344L36.0241 30.5339" stroke="currentColor" stroke-width="1.2"></path><path d="M6.1543 17.4299C6.38271 17.4299 6.56832 17.6154 6.56836 17.8439C6.56836 18.0723 6.38276 18.258 6.1543 18.258C5.92585 18.258 5.74023 18.0723 5.74023 17.8439C5.74028 17.6155 5.9259 17.4299 6.1543 17.4299Z" fill="currentColor" stroke="currentColor" stroke-width="0.881816"></path><path d="M6.1543 24.1223C6.38276 24.1223 6.56836 24.3079 6.56836 24.5363C6.56835 24.7648 6.3827 24.9504 6.1543 24.9504C5.92591 24.9504 5.74024 24.7648 5.74023 24.5363C5.74023 24.3079 5.92585 24.1223 6.1543 24.1223Z" fill="currentColor" stroke="currentColor" stroke-width="0.881816"></path><path d="M6.1543 10.7404C6.38269 10.7404 6.56833 10.9261 6.56836 11.1545C6.56836 11.3829 6.38276 11.5685 6.1543 11.5685C5.92585 11.5685 5.74023 11.3829 5.74023 11.1545C5.74027 10.9261 5.92592 10.7404 6.1543 10.7404Z" fill="currentColor" stroke="currentColor" stroke-width="0.881816"></path><path d="M12.6636 17.4299C12.8919 17.4299 13.0766 17.6154 13.0767 17.8439C13.0767 18.0723 12.892 18.258 12.6636 18.258C12.4351 18.258 12.2495 18.0724 12.2495 17.8439C12.2496 17.6154 12.4352 17.4299 12.6636 17.4299Z" fill="currentColor" stroke="currentColor" stroke-width="0.881816"></path><path d="M12.6636 24.1223C12.892 24.1223 13.0767 24.3079 13.0767 24.5363C13.0767 24.7648 12.8919 24.9504 12.6636 24.9504C12.4352 24.9504 12.2495 24.7648 12.2495 24.5363C12.2495 24.3079 12.4351 24.1223 12.6636 24.1223Z" fill="currentColor" stroke="currentColor" stroke-width="0.881816"></path><path d="M12.6636 10.7404C12.8919 10.7404 13.0766 10.9261 13.0767 11.1545C13.0767 11.3829 12.892 11.5685 12.6636 11.5685C12.4351 11.5685 12.2495 11.3829 12.2495 11.1545C12.2495 10.926 12.4352 10.7404 12.6636 10.7404Z" fill="currentColor" stroke="currentColor" stroke-width="0.881816"></path><path d="M19.1724 17.4299C19.4008 17.4299 19.5864 17.6155 19.5864 17.8439C19.5864 18.0723 19.4009 18.258 19.1724 18.258C18.944 18.258 18.7583 18.0723 18.7583 17.8439C18.7583 17.6154 18.944 17.4299 19.1724 17.4299Z" fill="currentColor" stroke="currentColor" stroke-width="0.881816"></path><path d="M19.1724 24.1223C19.4009 24.1223 19.5864 24.3079 19.5864 24.5363C19.5864 24.7647 19.4008 24.9504 19.1724 24.9504C18.944 24.9504 18.7583 24.7648 18.7583 24.5363C18.7583 24.3079 18.944 24.1223 19.1724 24.1223Z" fill="currentColor" stroke="currentColor" stroke-width="0.881816"></path><path d="M19.1724 10.7404C19.4008 10.7404 19.5864 10.9261 19.5864 11.1545C19.5864 11.3829 19.4009 11.5685 19.1724 11.5685C18.944 11.5685 18.7583 11.3829 18.7583 11.1545C18.7583 10.9261 18.9441 10.7404 19.1724 10.7404Z" fill="currentColor" stroke="currentColor" stroke-width="0.881816"></path><path d="M25.6812 17.4299C25.9095 17.4299 26.0952 17.6154 26.0952 17.8439C26.0952 18.0723 25.9095 18.258 25.6812 18.258C25.4526 18.258 25.2671 18.0723 25.2671 17.8439C25.2671 17.6155 25.4527 17.4299 25.6812 17.4299Z" fill="currentColor" stroke="currentColor" stroke-width="0.881816"></path><path d="M25.6812 24.1223C25.9095 24.1223 26.0952 24.3079 26.0952 24.5363C26.0952 24.7648 25.9095 24.9504 25.6812 24.9504C25.4527 24.9503 25.2671 24.7648 25.2671 24.5363C25.2671 24.3079 25.4526 24.1223 25.6812 24.1223Z" fill="currentColor" stroke="currentColor" stroke-width="0.881816"></path><path d="M25.6812 10.7404C25.9095 10.7404 26.0952 10.9261 26.0952 11.1545C26.0952 11.3829 25.9095 11.5685 25.6812 11.5685C25.4526 11.5685 25.2671 11.3829 25.2671 11.1545C25.2671 10.926 25.4527 10.7405 25.6812 10.7404Z" fill="currentColor" stroke="currentColor" stroke-width="0.881816"></path><path d="M32.1904 17.4299C32.4189 17.4299 32.6045 17.6155 32.6045 17.8439C32.6045 18.0723 32.4189 18.258 32.1904 18.258C31.962 18.258 31.7764 18.0723 31.7764 17.8439C31.7764 17.6154 31.9621 17.4299 32.1904 17.4299Z" fill="currentColor" stroke="currentColor" stroke-width="0.881816"></path><path d="M32.1904 24.1223C32.4189 24.1223 32.6045 24.3079 32.6045 24.5363C32.6045 24.7647 32.4189 24.9504 32.1904 24.9504C31.9621 24.9504 31.7764 24.7648 31.7764 24.5363C31.7764 24.3079 31.962 24.1223 32.1904 24.1223Z" fill="currentColor" stroke="currentColor" stroke-width="0.881816"></path><path d="M32.1904 10.7404C32.4189 10.7404 32.6045 10.9261 32.6045 11.1545C32.6045 11.3829 32.4189 11.5685 32.1904 11.5685C31.962 11.5685 31.7764 11.3829 31.7764 11.1545C31.7764 10.9261 31.9621 10.7404 32.1904 10.7404Z" fill="currentColor" stroke="currentColor" stroke-width="0.881816"></path></svg>',
};

class MainProductCustom {
  constructor(section) {
    this.section = section;
    this.productId = section.dataset.productId;
    this.productTitle = section.dataset.productTitle || '';
    this.productUrl = section.dataset.productUrl;
    this.variantDataScript = section.querySelector('[data-variant-data]');
    this.variantData = this.parseJSONScript(this.variantDataScript, []);
    this.linkedVariantMapScript = section.querySelector('[data-linked-product-variant-map]');
    this.variantAddonMapScript = section.querySelector('[data-variant-addon-map]');

    if (!this.variantData.length) return;

    const urlParams = new URLSearchParams(window.location.search);
    const urlVariantId = Number(urlParams.get('variant'));
    const hasAnyAvailable = this.variantData.some((v) => v.available);
    let initialVariant = null;

    if (urlVariantId) {
      initialVariant = this.variantData.find((variant) => Number(variant.id) === urlVariantId);
    }
    if (!initialVariant && section.dataset.selectedVariantId) {
      const selectedId = Number(section.dataset.selectedVariantId);
      initialVariant = this.variantData.find((variant) => Number(variant.id) === selectedId && (hasAnyAvailable ? variant.available : true));
    }
    if (!initialVariant) {
      initialVariant = (hasAnyAvailable ? this.variantData.find((variant) => variant.available) : null) || this.variantData[0];
    }

    this.currentVariant = initialVariant;
    this.selectedVariantId = Number(initialVariant.id);
    this.selectedOptions = [...this.currentVariant.options];
    this.mainVariantSelected = true;

    this.variantGroups = [...section.querySelectorAll('[data-option-index]')];
    this.productForm = section.querySelector('form[data-type="add-to-cart-form"]');
    this.hiddenIdInput = section.querySelector('[data-variant-id-input]');
    this.installmentInput = section.querySelector('[data-installment-variant-id]');
    this.linkedPropertyIdInput = section.querySelector('[data-linked-property-id]');
    this.linkedPropertyTitleInput = section.querySelector('[data-linked-property-title]');
    this.linkedPropertyPriceInput = section.querySelector('[data-linked-property-price]');
    this.linkedPropertyBundleTotalInput = section.querySelector('[data-linked-property-bundle-total]');
    this.headboardPropertyProductIdInput = section.querySelector('[data-headboard-property-product-id]');
    this.headboardPropertyProductTitleInput = section.querySelector('[data-headboard-property-product-title]');
    this.headboardPropertyVariantIdInput = section.querySelector('[data-headboard-property-variant-id]');
    this.headboardPropertyVariantTitleInput = section.querySelector('[data-headboard-property-variant-title]');
    this.headboardPropertyVariantPriceInput = section.querySelector('[data-headboard-property-variant-price]');
    this.deliveryPropertyProductIdInput = section.querySelector('[data-delivery-property-product-id]');
    this.deliveryPropertyProductTitleInput = section.querySelector('[data-delivery-property-product-title]');
    this.deliveryPropertyVariantIdInput = section.querySelector('[data-delivery-property-variant-id]');
    this.deliveryPropertyVariantTitleInput = section.querySelector('[data-delivery-property-variant-title]');
    this.deliveryPropertyVariantPriceInput = section.querySelector('[data-delivery-property-variant-price]');
    this.priceCompare = section.querySelector('[data-price-compare]');
    this.priceActual = section.querySelector('[data-price-actual]');
    this.saleBadge = section.querySelector('[data-sale-badge]');
    this.addToCartButton = section.querySelector('[data-add-to-cart]');
    this.linkedVariantsWrap = section.querySelector('[data-linked-product-variants-wrap]');
    this.linkedVariantsTitle = section.querySelector('[data-linked-product-title]');
    this.linkedVariantsContainer = section.querySelector('[data-linked-product-variants]');
    this.linkedVariantMap = this.parseJSONScript(this.linkedVariantMapScript, {});
    this.variantAddonMap = this.parseJSONScript(this.variantAddonMapScript, {});
    this.addonGroup = section.querySelector('[data-addon-group]');
    this.addonOptionsContainer = section.querySelector('[data-addon-options]');
    this.currentAddonOptions = [];
    this.selectedAddonId = null;
    this.selectedAddon = null;
    this.lastAddonVariantId = null;
    this.storageProductsRoot = section.querySelector('[data-storage-products-root]');
    this.storageProductCards = this.storageProductsRoot
      ? [...this.storageProductsRoot.querySelectorAll('[data-storage-product-card]')]
      : [];
    this.storageSelectionError = section.querySelector('[data-storage-selection-error]');
    this.headboardRoot = section.querySelector('[data-headboard-root]');
    this.headboardCards = this.headboardRoot
      ? [...this.headboardRoot.querySelectorAll('[data-headboard-card]')]
      : [];
    this.headboardSelect = section.querySelector('[data-headboard-select]');
    this.headboardSelectionError = section.querySelector('[data-headboard-selection-error]');
    this.deliveryRoot = section.querySelector('[data-delivery-root]');
    this.deliverySelect = section.querySelector('[data-delivery-select]');
    this.deliveryCard = section.querySelector('[data-delivery-card]');
    this.deliveryToggleBtn = section.querySelector('[data-delivery-toggle-btn]');
    this.deliverySelectionError = section.querySelector('[data-delivery-selection-error]');
    this.activeStorageProductId = null;
    this.selectedStorage = null;
    this.selectedHeadboard = null;
    this.selectedDelivery = null;
    this.linkedVariantButtonSelector = '[data-linked-variant-id]';
    this.selectedLinkedVariantId = null;
    this.currentLinkedProduct = null;
    this.linkedProductCache = {};
    this.linkedRenderRequestId = 0;

    // Nested cart line functionality start
    this.childProductsRoot = section.querySelector('[data-child-products]');
    this.selectedChildItems = [];
    // Nested cart line functionality end

    this.slides = [...section.querySelectorAll('[data-slide]')];
    this.thumbs = [...section.querySelectorAll('[data-thumb]')];
    this.dots = [...section.querySelectorAll('[data-slider-dot]')];
    this.sliderPrev = section.querySelector('[data-slider-prev]');
    this.sliderNext = section.querySelector('[data-slider-next]');
    this.thumbsPrev = section.querySelector('[data-thumbs-prev]');
    this.thumbsNext = section.querySelector('[data-thumbs-next]');
    this.thumbsContainer = section.querySelector('.custom-thumbs');
    this.currentSlideIndex = 0;
    this.debugBundle = true;
    this.showValidationErrors = false;

    this.bindEvents();
    this.initConfigTabs();
    this.initFabricSelection();
    this.initStorageSelection();
    this.initHeadboardSelection();
    this.initDeliverySelection();
    this.syncUI(true);
    this.initAccordion();
    this.initSizeChartPopup();
    this.initLightbox();
    console.log('[MainProductCustom] About to call initColorsLightbox');
    this.initColorsLightbox();
    // Child drawer restrictions start
    this.initChildDrawerRestrictions();
    // Child drawer restrictions end
  }

  bindEvents() {
    this.variantGroups.forEach((group) => {
      group.addEventListener('click', (event) => {
        const optionButton = event.target.closest('[data-option-value]');
        if (!optionButton || optionButton.classList.contains('is-unavailable')) return;

        const optionIndex = Number(group.dataset.optionIndex);
        const optionValue = optionButton.dataset.optionValue;

        this.selectedOptions[optionIndex] = optionValue;
        this.resolveVariant(optionIndex);
        this.mainVariantSelected = true;
        this.selectedLinkedVariantId = null;
        this.currentLinkedProduct = null;

        // Reset dependent options if unavailable
        if (this.storageProductCards.length > 0 && !this.hasValidStorageSelection()) {
          this.initStorageSelection();
        }
        if ((this.headboardCards.length > 0 || this.headboardSelect) && !this.hasValidHeadboardSelection()) {
          this.initHeadboardSelection();
        }

        this.logBundleDebug('main-variant-selected', {
          optionIndex,
          optionValue,
          mainVariantId: this.currentVariant ? this.currentVariant.id : null,
          mainVariantTitle: this.currentVariant ? this.currentVariant.title : null
        });
        this.syncUI();
      });
    });

    this.thumbs.forEach((thumb, index) => {
      thumb.addEventListener('click', () => {
        this.showSlide(index);
      });
    });

    this.dots.forEach((dot, index) => {
      dot.addEventListener('click', () => {
        this.showSlide(index);
      });
    });

    if (this.sliderPrev) {
      this.sliderPrev.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.showSlide((this.currentSlideIndex - 1 + this.slides.length) % this.slides.length);
      });
    }

    if (this.sliderNext) {
      this.sliderNext.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.showSlide((this.currentSlideIndex + 1) % this.slides.length);
      });
    }

    if (this.thumbsPrev) {
      this.thumbsPrev.addEventListener('click', (e) => {
        e.stopPropagation();
        if (this.slides.length > 0) {
          const nextIndex = (this.currentSlideIndex - 1 + this.slides.length) % this.slides.length;
          this.showSlide(nextIndex);
        }
      });
    }

    if (this.thumbsNext) {
      this.thumbsNext.addEventListener('click', (e) => {
        e.stopPropagation();
        if (this.slides.length > 0) {
          const nextIndex = (this.currentSlideIndex + 1) % this.slides.length;
          this.showSlide(nextIndex);
        }
      });
    }

    if (this.linkedVariantsContainer) {
      this.linkedVariantsContainer.addEventListener('click', (event) => {
        const linkedOption = event.target.closest(this.linkedVariantButtonSelector);
        if (!linkedOption || linkedOption.disabled) return;

        this.selectedLinkedVariantId = Number(linkedOption.dataset.linkedVariantId);
        const linkedVariant = this.getSelectedLinkedVariant();
        this.logBundleDebug('linked-variant-selected', {
          linkedVariantId: this.selectedLinkedVariantId,
          linkedVariantTitle: linkedVariant ? linkedVariant.title : null,
          linkedVariantPrice: linkedVariant ? linkedVariant.price : null,
          linkedVariantAvailable: linkedVariant ? linkedVariant.available : null
        });
        this.updateLinkedVariantButtonState();
        this.updateLinkedLineItemProperties();
        this.updatePrice();
        this.updateButtonState();
        this.updateSummaryChips();
        this.section.dispatchEvent(new CustomEvent('linked:variant:change', {
          bubbles: true,
          detail: {
            mainVariant: this.currentVariant,
            linkedVariantId: this.selectedLinkedVariantId
          }
        }));
      });
    }

    this.section.addEventListener('variant:change', (event) => {
      const variantId = Number(event.detail && event.detail.variant && event.detail.variant.id);
      if (variantId && (!this.currentVariant || variantId !== Number(this.currentVariant.id))) {
        const match = this.variantData.find((variant) => Number(variant.id) === variantId);
        if (match) {
          const previousVariantId = this.currentVariant ? Number(this.currentVariant.id) : null;
          this.currentVariant = match;
          this.selectedOptions = [...match.options];
          this.mainVariantSelected = true;
          if (previousVariantId !== Number(match.id)) {
            this.selectedLinkedVariantId = null;
            this.currentLinkedProduct = null;
          }
          this.syncUI();
        }
      }
    });

    document.addEventListener('variant:change', (event) => {
      if (!this.section.contains(event.target) && event.target !== this.section) return;

      const variantId = Number(event.detail && event.detail.variant && event.detail.variant.id);
      if (variantId && (!this.currentVariant || variantId !== Number(this.currentVariant.id))) {
        const match = this.variantData.find((variant) => Number(variant.id) === variantId);
        if (match) {
          const previousVariantId = this.currentVariant ? Number(this.currentVariant.id) : null;
          this.currentVariant = match;
          this.selectedOptions = [...match.options];
          this.mainVariantSelected = true;
          if (previousVariantId !== Number(match.id)) {
            this.selectedLinkedVariantId = null;
            this.currentLinkedProduct = null;
          }
          this.syncUI();
        }
      }
    });

    if (this.productForm) {
      this.productForm.addEventListener('submit', (event) => {
        this.logBundleDebug('submit-captured', {
          canAdd: this.canAddToCart(),
          mainVariantId: this.currentVariant ? this.currentVariant.id : null,
          linkedVariantId: this.selectedLinkedVariantId
        });
        this.handleBundleSubmit(event);
      }, true);
    }

    if (this.addonOptionsContainer) {
      this.addonOptionsContainer.addEventListener('click', (event) => {
        const addonOption = event.target.closest('[data-addon-option-id]');
        if (!addonOption || addonOption.disabled) return;

        const addonId = addonOption.dataset.addonOptionId;
        const selected = this.currentAddonOptions.find((item) => String(item.id) === String(addonId));
        this.selectedAddonId = addonId || null;
        this.selectedAddon = selected || null;

        this.updateAddonOptionState();
        this.updatePrice();
      });
    }

    if (this.storageProductsRoot) {
      this.storageProductsRoot.addEventListener('click', (event) => {
        this.handleStorageSelectionClick(event);
      });
    }

    if (this.headboardRoot) {
      this.headboardRoot.addEventListener('click', (event) => {
        this.handleHeadboardSelectionClick(event);
      });
    }

    if (this.headboardSelect) {
      this.headboardSelect.addEventListener('change', () => {
        this.handleHeadboardSelectionChange();
      });
    }

    if (this.deliverySelect) {
      this.deliverySelect.addEventListener('change', () => {
        this.handleDeliverySelectionChange();
      });
    }

    if (this.deliveryToggleBtn) {
      this.deliveryToggleBtn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.toggleDeliveryCardSelection();
      });
    }

    if (this.deliveryCard) {
      this.deliveryCard.addEventListener('click', (e) => {
        if (e.target.closest('[data-delivery-toggle-btn]')) return;
        this.toggleDeliveryCardSelection();
      });
    }

    // Nested cart line functionality start
    if (this.childProductsRoot) {
      this.childProductsRoot.addEventListener('change', (event) => {
        const checkbox = event.target.closest('[data-child-checkbox]');
        if (!checkbox) return;
        this.syncChildSelections();
        this.updatePrice();
      });
    }
    // Nested cart line functionality end
  }

  resolveVariant(changedIndex) {
    let match = this.variantData.find((variant) =>
      variant.options.every((value, index) => value === this.selectedOptions[index])
    );

    
    if (!match) {
      match =
        this.variantData.find((variant) => variant.available && variant.options[changedIndex] === this.selectedOptions[changedIndex]) ||
        this.variantData.find((variant) => variant.options[changedIndex] === this.selectedOptions[changedIndex]) ||
        this.variantData[0];

      this.selectedOptions = [...match.options];
    }

    this.currentVariant = match;
  }

  syncUI(isInitial = false) {
    this.updateVariantCards();
    this.updateLinkedProductVariants(isInitial);
    this.updateVariantAddonOptions();
    this.updateLinkedLineItemProperties();
    this.updateHeadboardLineItemProperties();
    this.updateDeliveryLineItemProperties();
    this.updatePrice();
    this.updateFormVariantId();
    this.updateURL();
    this.updateSaleBadge();
    this.updateButtonState();
    this.updateSummaryChips();
    this.emitVariantChange();

    if (!isInitial) {
      this.syncSliderWithVariant();
    }
  }

  emitVariantChange() {
    if (!this.currentVariant || !this.mainVariantSelected) return;

    this.section.dispatchEvent(new CustomEvent('variant:change', {
      bubbles: true,
      detail: {
        sectionId: this.section.id,
        variant: this.currentVariant
      }
    }));
  }

  updateVariantCards() {
    this.variantGroups.forEach((group) => {
      const groupIndex = Number(group.dataset.optionIndex);
      const cards = [...group.querySelectorAll('[data-option-value]')];

      cards.forEach((card) => {
        const value = card.dataset.optionValue;
        const isActive = this.mainVariantSelected && this.selectedOptions[groupIndex] === value;
        card.classList.toggle('is-active', isActive);

        const candidate = this.variantData.filter((variant) => {
          return variant.options[groupIndex] === value && variant.options.every((optionValue, optionIndex) => {
            if (optionIndex === groupIndex) return true;
            return optionValue === this.selectedOptions[optionIndex];
          });
        });

        const exists = candidate.length > 0;
        card.classList.toggle('is-unavailable', !exists);
        card.setAttribute('aria-pressed', String(isActive));
      });
    });
  }

  updatePrice() {
    if (!this.currentVariant || !this.priceActual) return;

    const moneyFormat = window.theme && window.theme.moneyFormat ? window.theme.moneyFormat : '£{{amount}}';
    const formatMoney = window.Shopify && window.Shopify.formatMoney
      ? (value) => window.Shopify.formatMoney(value, moneyFormat)
      : (value) => `${(value / 100).toFixed(2)}`;

    const linkedVariant = this.getSelectedLinkedVariant();
    const addonPrice = this.selectedAddon ? Number(this.selectedAddon.priceCents || 0) : 0;
    const storagePrice = this.getSelectedStoragePrice();
    const headboardPrice = this.getSelectedHeadboardPrice();
    const deliveryPrice = this.getSelectedDeliveryPrice();
    // Nested cart line functionality start
    const childPrice = this.getSelectedChildTotalPrice();
    // Nested cart line functionality end
    const combinedPrice = this.mainVariantSelected && linkedVariant
      ? Number(this.currentVariant.price) + Number(linkedVariant.price || 0) + addonPrice + storagePrice + headboardPrice + deliveryPrice + childPrice
      : Number(this.currentVariant.price) + addonPrice + storagePrice + headboardPrice + deliveryPrice + childPrice;
    const actual = formatMoney(combinedPrice);
    this.priceActual.innerHTML = actual;

    if (linkedVariant) {
      this.priceCompare.setAttribute('hidden', 'hidden');
      this.priceCompare.innerHTML = '';
      return;
    }

    if (this.currentVariant.compare_at_price && this.currentVariant.compare_at_price > this.currentVariant.price) {
      this.priceCompare.innerHTML = formatMoney(this.currentVariant.compare_at_price);
      this.priceCompare.removeAttribute('hidden');
    } else {
      this.priceCompare.setAttribute('hidden', 'hidden');
      this.priceCompare.innerHTML = '';
    }
  }

  updateFormVariantId() {
    if (!this.currentVariant) return;

    if (this.hiddenIdInput) {
      this.hiddenIdInput.value = this.mainVariantSelected ? this.currentVariant.id : '';
      this.hiddenIdInput.dispatchEvent(new Event('change', { bubbles: true }));
    }

    if (this.installmentInput) {
      this.installmentInput.value = this.mainVariantSelected ? this.currentVariant.id : '';
      this.installmentInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  updateURL() {
    if (!this.currentVariant || !this.productUrl) return;
    if (this.mainVariantSelected) {
      window.history.replaceState({}, '', `${this.productUrl}?variant=${this.currentVariant.id}`);
    } else {
      window.history.replaceState({}, '', this.productUrl);
    }
  }

  updateSaleBadge() {
    if (!this.saleBadge || !this.currentVariant) return;

    const hasSale =
      this.currentVariant.compare_at_price &&
      Number(this.currentVariant.compare_at_price) > Number(this.currentVariant.price);

    this.saleBadge.toggleAttribute('hidden', !hasSale);
  }

  updateButtonState() {
    if (!this.addToCartButton || !this.currentVariant) return;

    const hasAnyAvailable = this.variantData.some((v) => v.available);
    const available = hasAnyAvailable ? Boolean(this.currentVariant.available) : true;
    this.addToCartButton.disabled = !available;
    const atcLabel = this.addToCartButton.querySelector('.custom-add-to-cart__label') || this.addToCartButton;
    atcLabel.textContent = available
      ? (this.addToCartButton.dataset.addToCartLabel || 'Add to cart')
      : (this.addToCartButton.dataset.soldOutLabel || 'Sold out');

    if (this.showValidationErrors) {
      this.updateRequiredFieldErrors();
    }
  }

  getValidationState() {
    const missingMainVariant = !this.mainVariantSelected;
    const hasLinkedProduct = Boolean(
      this.currentLinkedProduct &&
      Array.isArray(this.currentLinkedProduct.variants) &&
      this.currentLinkedProduct.variants.length > 0
    );
    const missingLinkedVariant = hasLinkedProduct ? !Boolean(this.getSelectedLinkedVariant()) : false;
    const missingFabric = !this.hasValidFabricSelection();
    const missingStorage = !this.hasValidStorageSelection();
    const missingHeadboard = !this.hasValidHeadboardSelection();
    const missingDelivery = !this.hasValidDeliverySelection();

    // Only flag options as missing if they are actually available for this product
    const hasStorageOptions = this.storageProductCards.length > 0;
    const hasHeadboardOptions = this.headboardCards.length > 0 || Boolean(this.headboardSelect);
    const hasDeliveryOptions = false; // Delivery is an optional add-on

    const missingStorageTab = missingStorage && hasStorageOptions;
    const missingHeadboardTab = missingHeadboard && hasHeadboardOptions;
    const missingDeliveryTab = missingDelivery && hasDeliveryOptions;

    return {
      missingMainVariant,
      missingLinkedVariant,
      missingFabric,
      missingStorage,
      missingHeadboard,
      missingDelivery,
      missingSizeTab: missingMainVariant || missingLinkedVariant,
      missingStorageTab: missingStorageTab,
      missingHeadboardTab: missingHeadboardTab,
      missingDeliveryTab: missingDeliveryTab
    };
  }

  toggleRequiredState(element, isMissing) {
    if (!element) return;
    element.classList.toggle('is-required-missing', Boolean(isMissing));
  }

  openConfigTab(targetKey) {
    if (!targetKey) return;
    const trigger = this.section.querySelector(`[data-config-tab-trigger][data-config-tab-target="${targetKey}"]`);
    if (trigger) {
      trigger.click();
    }
  }

  focusFirstMissingConfigTab(validation) {
    if (validation.missingSizeTab) {
      this.openConfigTab('size');
      return;
    }

    if (validation.missingFabric) {
      this.openConfigTab('fabric');
      return;
    }

    if (validation.missingStorageTab) {
      this.openConfigTab('storage');
      return;
    }

    if (validation.missingHeadboardTab) {
      this.openConfigTab('headboard');
    }
  }

  updateRequiredFieldErrors() {
    const validation = this.getValidationState();
    const sizeTrigger = this.section.querySelector('[data-config-tab-trigger][data-config-tab-target="size"]');
    const fabricTrigger = this.section.querySelector('[data-config-tab-trigger][data-config-tab-target="fabric"]');
    const storageTrigger = this.section.querySelector('[data-config-tab-trigger][data-config-tab-target="storage"]');
    const headboardTrigger = this.section.querySelector('[data-config-tab-trigger][data-config-tab-target="headboard"]');
    const sizePanelGroup = this.section.querySelector('[data-config-tab-panel="size"] .custom-variant-groups');
    const fabricSelection = this.section.querySelector('.custom-color-selection');

    this.toggleRequiredState(sizeTrigger, validation.missingSizeTab);
    this.toggleRequiredState(fabricTrigger, validation.missingFabric);
    this.toggleRequiredState(storageTrigger, validation.missingStorageTab);
    this.toggleRequiredState(headboardTrigger, validation.missingHeadboardTab);
    this.toggleRequiredState(sizePanelGroup, validation.missingSizeTab);
    this.toggleRequiredState(this.linkedVariantsWrap, validation.missingLinkedVariant);
    this.toggleRequiredState(fabricSelection, validation.missingFabric);
    this.toggleRequiredState(this.storageProductsRoot, validation.missingStorageTab);
    this.toggleRequiredState(this.headboardRoot, validation.missingHeadboardTab);
    this.toggleRequiredState(this.deliveryRoot, validation.missingDeliveryTab);

    this.setStorageSelectionError(validation.missingStorageTab);
    this.setHeadboardSelectionError(validation.missingHeadboardTab);
    this.setDeliverySelectionError(validation.missingDeliveryTab);
  }

  async updateLinkedProductVariants(isInitial = false) {
    if (!this.linkedVariantsContainer || !this.currentVariant) return;

    if (!this.mainVariantSelected) {
      this.currentLinkedProduct = null;
      this.selectedLinkedVariantId = null;
      if (this.linkedVariantsWrap) {
        this.linkedVariantsWrap.hidden = true;
      }

      this.linkedVariantsContainer.innerHTML = '';
      this.linkedVariantsContainer.hidden = true;
      if (this.linkedVariantsTitle) {
        this.linkedVariantsTitle.hidden = true;
        this.linkedVariantsTitle.style.display = 'none';
      }

      // Remove dynamic tab if it exists
      const dynamicTab = this.section.querySelector('[data-config-tab-trigger][data-config-tab-target="linked-variants"]');
      if (dynamicTab) {
        dynamicTab.remove();
      }
      // Ensure size tab is active if dynamic tab was active
      const activeTab = this.section.querySelector('[data-config-tab-trigger].is-active');
      if (!activeTab || activeTab.dataset.configTabTarget === 'linked-variants') {
        this.setActiveTab('size');
      }

      return;
    }

    const requestId = ++this.linkedRenderRequestId;
    const currentVariantId = String(this.currentVariant.id);
    let linkedProduct = this.linkedVariantMap[currentVariantId];

    if (linkedProduct && (!Array.isArray(linkedProduct.variants) || !linkedProduct.variants.length)) {
      linkedProduct = await this.fetchLinkedProductData(linkedProduct);
      this.linkedVariantMap[currentVariantId] = linkedProduct;
    }

    if (requestId !== this.linkedRenderRequestId) return;

    if (!linkedProduct || !Array.isArray(linkedProduct.variants) || !linkedProduct.variants.length) {
      this.logBundleDebug('linked-variants-missing', {
        currentVariantId,
        linkedProduct
      });
      this.currentLinkedProduct = null;
      this.selectedLinkedVariantId = null;
      if (this.linkedVariantsWrap) {
        this.linkedVariantsWrap.hidden = true;
      }

      this.linkedVariantsContainer.innerHTML = '';
      this.linkedVariantsContainer.hidden = true;
      if (this.linkedVariantsTitle) {
        this.linkedVariantsTitle.hidden = true;
        this.linkedVariantsTitle.style.display = 'none';
      }

      // Remove dynamic tab if it exists
      const dynamicTab = this.section.querySelector('[data-config-tab-trigger][data-config-tab-target="linked-variants"]');
      if (dynamicTab) {
        dynamicTab.remove();
      }
      // Ensure size tab is active if dynamic tab was active
      const activeTab = this.section.querySelector('[data-config-tab-trigger].is-active');
      if (!activeTab || activeTab.dataset.configTabTarget === 'linked-variants') {
        this.setActiveTab('size');
      }

      return;
    }

    this.currentLinkedProduct = linkedProduct;
    this.logBundleDebug('linked-variants-loaded', {
      currentVariantId,
      linkedProductId: linkedProduct.id,
      linkedProductTitle: linkedProduct.title,
      variantsCount: linkedProduct.variants.length
    });
    const hasAnyAvailableLinked = linkedProduct.variants.some((v) => v.available);
    const hasExistingSelected = linkedProduct.variants.some(
      (variant) => Number(variant.id) === Number(this.selectedLinkedVariantId) && (hasAnyAvailableLinked ? variant.available : true)
    );
    if (!hasExistingSelected) {
      let defaultLinked = linkedProduct.variants.find(
        (v) => v.title && /no\s*mattress/i.test(v.title.trim()) && (hasAnyAvailableLinked ? v.available : true)
      );
      if (!defaultLinked && hasAnyAvailableLinked) {
        defaultLinked = [...linkedProduct.variants].reverse().find((v) => v.available);
      }
      if (!defaultLinked) {
        defaultLinked = linkedProduct.variants[linkedProduct.variants.length - 1];
      }
      this.selectedLinkedVariantId = defaultLinked ? Number(defaultLinked.id) : null;
    }

    const titleText = this.currentVariant && this.currentVariant.title
      ? this.currentVariant.title
      : (linkedProduct.title || 'Mattress');

    if (this.linkedVariantsTitle) {
      this.linkedVariantsTitle.textContent = titleText;
      this.linkedVariantsTitle.hidden = true;
      this.linkedVariantsTitle.style.display = 'none';
    }

    this.linkedVariantsContainer.innerHTML = linkedProduct.variants
      .map((variant) => {
        const variantId = Number(variant.id);
        const isActive = this.selectedLinkedVariantId === variantId;
        const title = this.escapeHTML(variant.title || 'Default Title');
        const price = this.formatMoney(variant.price);
        const image = variant.image
          ? `<span class="linked-variant-option-image"><img src="${this.escapeHTML(String(variant.image))}" alt="${title}" width="100" height="75" loading="lazy"></span>`
          : '';
        const isDisabled = hasAnyAvailableLinked ? !variant.available : false;
        const checkBadge = `<span class="custom-variant-option-check" aria-hidden="true"><svg viewBox="0 0 24 24" style="width:12px;height:12px;fill:none;stroke:currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" focusable="false"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg></span>`;

        return `<button type="button" class="linked-variant-option${isActive ? ' is-active' : ''}" data-linked-variant-id="${variantId}" ${isDisabled ? 'disabled' : ''}>${checkBadge}${image}<span class="linked-variant-option-content"><span class="linked-variant-option-title">${title}</span><span class="linked-variant-option-price">${price}</span></span></button>`;
      })
      .join('');

    this.linkedVariantsContainer.hidden = false;
    if (this.linkedVariantsWrap) {
      this.linkedVariantsWrap.hidden = false;
    }

    this.updateLinkedVariantButtonState();

    // Dynamically update mattress tab and link to size
    this.updateOrCreateDynamicTab(titleText);
    if (!isInitial) {
      this.setActiveTab('linked-variants');
    } else {
      const activeTab = this.section.querySelector('[data-config-tab-trigger].is-active');
      if (!activeTab) {
        this.setActiveTab('size');
      } else {
        this.setActiveTab(activeTab.dataset.configTabTarget);
      }
    }

    this.updateLinkedLineItemProperties();
    this.updatePrice();
    this.updateButtonState();
    this.updateSummaryChips();
  }

  async fetchLinkedProductData(linkedProduct) {
    if (!linkedProduct) return null;

    const cacheKey = String(linkedProduct.id || linkedProduct.handle || linkedProduct.url || '');
    if (cacheKey && this.linkedProductCache[cacheKey]) {
      return this.linkedProductCache[cacheKey];
    }

    const endpoint = this.buildLinkedProductJsonUrl(linkedProduct);
    if (!endpoint) return linkedProduct;

    try {
      const response = await fetch(endpoint, { credentials: 'same-origin' });
      if (!response.ok) return linkedProduct;

      const data = await response.json();
      const normalized = {
        id: data.id,
        title: data.title,
        handle: data.handle,
        url: data.url,
        variants: Array.isArray(data.variants)
          ? data.variants.map((variant) => ({
            id: variant.id,
            title: variant.public_title || variant.title || 'Default Title',
            available: Boolean(variant.available),
            price: variant.price,
            image: variant.featured_image && (variant.featured_image.src || variant.featured_image.url)
              ? (variant.featured_image.src || variant.featured_image.url)
              : null
          }))
          : []
      };

      if (cacheKey) {
        this.linkedProductCache[cacheKey] = normalized;
      }

      return normalized;
    } catch (error) {
      return linkedProduct;
    }
  }

  parseJSONScript(scriptElement, fallbackValue) {
    if (!scriptElement) return fallbackValue;

    try {
      return JSON.parse(scriptElement.textContent);
    } catch (error) {
      return fallbackValue;
    }
  }

  buildLinkedProductJsonUrl(linkedProduct) {
    const urlSource = linkedProduct.url || (linkedProduct.handle ? `/products/${linkedProduct.handle}` : '');
    if (!urlSource) return '';

    const path = String(urlSource).split('?')[0].replace(/\/$/, '');
    if (!path) return '';

    return path.endsWith('.js') ? path : `${path}.js`;
  }

  updateLinkedVariantButtonState() {
    if (!this.linkedVariantsContainer) return;

    this.linkedVariantsContainer.querySelectorAll(this.linkedVariantButtonSelector).forEach((button) => {
      const buttonVariantId = Number(button.dataset.linkedVariantId);
      const isActive = buttonVariantId === this.selectedLinkedVariantId;
      button.classList.toggle('is-active', isActive);
      button.setAttribute('aria-pressed', String(isActive));
    });
  }

  updateVariantAddonOptions() {
    if (!this.addonGroup || !this.addonOptionsContainer || !this.currentVariant) return;

    const variantId = String(this.currentVariant.id);
    const options = Array.isArray(this.variantAddonMap[variantId]) ? this.variantAddonMap[variantId] : [];
    const hasVariantChanged = this.lastAddonVariantId !== variantId;

    this.currentAddonOptions = options;
    this.lastAddonVariantId = variantId;

    if (!options.length) {
      this.addonGroup.hidden = true;
      this.addonOptionsContainer.hidden = true;
      this.addonOptionsContainer.innerHTML = '';
      this.selectedAddonId = null;
      this.selectedAddon = null;
      return;
    }

    this.addonGroup.hidden = false;
    this.addonOptionsContainer.hidden = false;

    const hasExistingSelection = !hasVariantChanged && options.some((item) => String(item.id) === String(this.selectedAddonId));
    if (!hasExistingSelection) {
      this.selectedAddonId = null;
      this.selectedAddon = null;
    } else {
      this.selectedAddon = options.find((item) => String(item.id) === String(this.selectedAddonId)) || null;
    }

    this.addonOptionsContainer.innerHTML = options
      .map((item) => {
        const id = String(item.id || '');
        const title = this.escapeHTML(item.title || 'Add-on');
        const priceCents = Number(item.priceCents || 0);
        const priceLabel = item.priceLabel ? this.escapeHTML(item.priceLabel) : this.escapeHTML(this.formatMoney(priceCents));
        const image = item.image ? `<img src="${this.escapeHTML(String(item.image))}" alt="${title}" width="80" height="80" loading="lazy">` : '';
        const isActive = String(this.selectedAddonId) === id;

        return `<button type="button" class="custom-addon-option${isActive ? ' is-active' : ''}" data-addon-option-id="${id}" aria-pressed="${isActive ? 'true' : 'false'}"><span class="custom-addon-option-image">${image}</span><span class="custom-addon-option-content"><span class="custom-addon-option-title">${title}</span><span class="custom-addon-option-price">${priceLabel}</span></span></button>`;
      })
      .join('');

    this.updateAddonOptionState();
  }

  updateAddonOptionState() {
    if (!this.addonOptionsContainer) return;

    this.addonOptionsContainer.querySelectorAll('[data-addon-option-id]').forEach((button) => {
      const isActive = String(button.dataset.addonOptionId) === String(this.selectedAddonId);
      button.classList.toggle('is-active', isActive);
      button.setAttribute('aria-pressed', String(isActive));
    });
  }

  getSelectedLinkedVariant() {
    if (!this.currentLinkedProduct || !Array.isArray(this.currentLinkedProduct.variants)) return null;
    return this.currentLinkedProduct.variants.find(
      (variant) => Number(variant.id) === Number(this.selectedLinkedVariantId)
    ) || null;
  }

  updateLinkedLineItemProperties() {
    const linkedVariant = this.getSelectedLinkedVariant();
    const mainPrice = this.mainVariantSelected && this.currentVariant ? Number(this.currentVariant.price) : 0;
    const linkedPrice = linkedVariant ? Number(linkedVariant.price || 0) : 0;
    const bundleTotal = mainPrice + linkedPrice;

    if (this.linkedPropertyIdInput) {
      this.linkedPropertyIdInput.value = linkedVariant ? String(linkedVariant.id) : '';
    }

    if (this.linkedPropertyTitleInput) {
      this.linkedPropertyTitleInput.value = linkedVariant ? String(linkedVariant.title || '') : '';
    }

    if (this.linkedPropertyPriceInput) {
      this.linkedPropertyPriceInput.value = linkedVariant ? String(linkedPrice) : '';
    }

    if (this.linkedPropertyBundleTotalInput) {
      this.linkedPropertyBundleTotalInput.value = linkedVariant ? String(bundleTotal) : '';
    }
  }

  updateHeadboardLineItemProperties() {
    const headboardProductId = this.headboardRoot ? String(this.headboardRoot.dataset.headboardProductId || '') : '';
    const headboardProductTitle = this.headboardRoot ? String(this.headboardRoot.dataset.headboardProductTitle || '') : '';
    const selectedHeadboard = this.selectedHeadboard;

    if (this.headboardPropertyProductIdInput) {
      this.headboardPropertyProductIdInput.value = selectedHeadboard ? headboardProductId : '';
    }

    if (this.headboardPropertyProductTitleInput) {
      this.headboardPropertyProductTitleInput.value = selectedHeadboard ? headboardProductTitle : '';
    }

    if (this.headboardPropertyVariantIdInput) {
      this.headboardPropertyVariantIdInput.value = selectedHeadboard ? String(selectedHeadboard.variantId || '') : '';
    }

    if (this.headboardPropertyVariantTitleInput) {
      this.headboardPropertyVariantTitleInput.value = selectedHeadboard ? String(selectedHeadboard.title || '') : '';
    }

    if (this.headboardPropertyVariantPriceInput) {
      this.headboardPropertyVariantPriceInput.value = selectedHeadboard ? String(Number(selectedHeadboard.price || 0)) : '';
    }
  }

  updateDeliveryLineItemProperties() {
    const deliveryProductId = this.deliveryRoot ? String(this.deliveryRoot.dataset.deliveryProductId || '') : '';
    const deliveryProductTitle = this.deliveryRoot ? String(this.deliveryRoot.dataset.deliveryProductTitle || '') : '';
    const selectedDelivery = this.selectedDelivery;

    if (this.deliveryPropertyProductIdInput) {
      this.deliveryPropertyProductIdInput.value = selectedDelivery ? deliveryProductId : '';
    }

    if (this.deliveryPropertyProductTitleInput) {
      this.deliveryPropertyProductTitleInput.value = selectedDelivery ? deliveryProductTitle : '';
    }

    if (this.deliveryPropertyVariantIdInput) {
      this.deliveryPropertyVariantIdInput.value = selectedDelivery ? String(selectedDelivery.variantId || '') : '';
    }

    if (this.deliveryPropertyVariantTitleInput) {
      this.deliveryPropertyVariantTitleInput.value = selectedDelivery ? String(selectedDelivery.title || '') : '';
    }

    if (this.deliveryPropertyVariantPriceInput) {
      this.deliveryPropertyVariantPriceInput.value = selectedDelivery ? String(Number(selectedDelivery.price || 0)) : '';
    }
  }

  canAddToCart() {
    if (!this.mainVariantSelected || !this.currentVariant) return false;
    const hasAnyAvailable = this.variantData.some((v) => v.available);
    if (hasAnyAvailable && !this.currentVariant.available) return false;

    if (this.currentLinkedProduct && Array.isArray(this.currentLinkedProduct.variants) && this.currentLinkedProduct.variants.length > 0) {
      const linkedVariant = this.getSelectedLinkedVariant();
      if (!linkedVariant) return false;
      const hasAnyLinkedAvailable = this.currentLinkedProduct.variants.some((v) => v.available);
      if (hasAnyLinkedAvailable && !linkedVariant.available) return false;
    }

    if (!this.hasValidFabricSelection()) return false;
    if (!this.hasValidStorageSelection()) return false;
    if (!this.hasValidHeadboardSelection()) return false;
    if (!this.hasValidDeliverySelection()) return false;

    return true;
  }

  getActiveFabricSelection() {
    const activeFabricBlock = this.section.querySelector('.fabric-block.fabric-active');
    if (!activeFabricBlock) return null;

    const activeFabricIndex = activeFabricBlock.dataset.fabricIndex || '';
    const fabricTitleElement = activeFabricBlock.querySelector('.main-fabric__title');
    const fabricName = fabricTitleElement ? fabricTitleElement.textContent.trim() : '';

    if (activeFabricIndex === 'same-as-main') {
      return {
        index: activeFabricIndex,
        fabricName,
        fabricColorName: '',
        sameAsMain: true
      };
    }

    const matchingColorList = this.section.querySelector(`.fabric-color-list[data-fabric-index="${activeFabricIndex}"]`);
    if (!matchingColorList || !matchingColorList.classList.contains('fabric-active')) {
      return {
        index: activeFabricIndex,
        fabricName,
        fabricColorName: '',
        sameAsMain: false
      };
    }

    const activeColorItem = matchingColorList.querySelector('.fabric-color-item.fabric-color-item-active, .fabric-color-item.fabric-color-item-avtive');
    const fabricColorName = activeColorItem
      ? String(activeColorItem.dataset.color || '').trim() || String(activeColorItem.textContent || '').trim()
      : '';

    return {
      index: activeFabricIndex,
      fabricName,
      fabricColorName,
      sameAsMain: false
    };
  }

  hasValidFabricSelection() {
    const fabricSelection = this.getActiveFabricSelection();
    if (!fabricSelection) return false;
    if (fabricSelection.sameAsMain) return true;

    return Boolean(fabricSelection.fabricColorName);
  }

  async handleBundleSubmit(event) {
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    if (!this.canAddToCart()) {
      this.showValidationErrors = true;
      const validation = this.getValidationState();
      this.updateRequiredFieldErrors();
      this.focusFirstMissingConfigTab(validation);
      this.logBundleDebug('submit-blocked', {
        reason: 'canAddToCart=false',
        mainVariantSelected: this.mainVariantSelected,
        mainVariantAvailable: this.currentVariant ? this.currentVariant.available : null,
        linkedVariant: this.getSelectedLinkedVariant(),
        hasValidFabricSelection: this.hasValidFabricSelection(),
        activeFabricIndex: (() => {
          const activeFabric = this.section.querySelector('.fabric-block.fabric-active');
          return activeFabric ? activeFabric.dataset.fabricIndex : null;
        })()
      });
      return;
    }

    this.showValidationErrors = false;
    this.updateRequiredFieldErrors();

    const hasLinkedVariants = Boolean(this.currentLinkedProduct && Array.isArray(this.currentLinkedProduct.variants) && this.currentLinkedProduct.variants.length > 0);
    const linkedVariant = this.getSelectedLinkedVariant();
    if (hasLinkedVariants && !linkedVariant) {
      this.logBundleDebug('submit-blocked', {
        reason: 'linkedVariant-null-after-guard'
      });
      return;
    }

    const fabricSelection = this.getActiveFabricSelection();
    if (!fabricSelection) {
      this.logBundleDebug('submit-blocked', {
        reason: 'fabric-selection-null-after-guard'
      });
      return;
    }

    if (!this.hasValidStorageSelection()) {
      this.setStorageSelectionError(true);
      this.logBundleDebug('submit-blocked', {
        reason: 'storage-selection-missing',
        selectedStorage: this.selectedStorage
      });
      return;
    }

    if (!this.hasValidHeadboardSelection()) {
      this.setHeadboardSelectionError(true);
      this.logBundleDebug('submit-blocked', {
        reason: 'headboard-selection-missing',
        selectedHeadboard: this.selectedHeadboard
      });
      return;
    }

    if (!this.hasValidDeliverySelection()) {
      this.setDeliverySelectionError(true);
      this.logBundleDebug('submit-blocked', {
        reason: 'delivery-selection-missing',
        selectedDelivery: this.selectedDelivery
      });
      return;
    }

    const submitButton = this.addToCartButton;
    if (submitButton) {
      submitButton.disabled = true;
      submitButton.classList.add('loading');
      submitButton.setAttribute('aria-busy', 'true');
    }

    const visibleFabricName = String(fabricSelection.fabricName || '');
    const visibleFabricColor = fabricSelection.sameAsMain
      ? 'Same As Main Display Picture'
      : String(fabricSelection.fabricColorName || '');
    const addonTitle = this.selectedAddon ? String(this.selectedAddon.title || '') : '';
    const addonPriceCents = this.selectedAddon ? Number(this.selectedAddon.priceCents || 0) : 0;
    const addonPriceLabel = this.selectedAddon
      ? String(this.selectedAddon.priceLabel || this.formatMoney(addonPriceCents))
      : '';
    const storageSelection = this.selectedStorage;
    const storagePriceCents = storageSelection ? Number(storageSelection.price || 0) : 0;
    const headboardSelection = this.selectedHeadboard;
    const headboardPriceCents = headboardSelection ? Number(headboardSelection.price || 0) : 0;
    const headboardProductTitle = this.headboardRoot ? String(this.headboardRoot.dataset.headboardProductTitle || '') : '';
    const deliverySelection = this.selectedDelivery;
    const deliveryPriceCents = deliverySelection ? Number(deliverySelection.price || 0) : 0;
    const deliveryProductTitle = this.deliveryRoot ? String(this.deliveryRoot.dataset.deliveryProductTitle || '') : '';
    // Nested cart line functionality start
    const childItemsForPayload = this.getSelectedChildItems();
    // parentVariantId is the Shopify variant ID of the main product.
    // ALL child lines reference this ID via parent_id in the same /cart/add.js call,
    // which is how Shopify AJAX Cart API creates true nested cart line hierarchy.
    const parentVariantId = Number(this.currentVariant.id);

    // Parent line carries only customer-facing display properties.
    // Hierarchy is enforced by Shopify via parent_id on child items — no bundle hacks.
    const mainItemProperties = {
      Fabric: visibleFabricName,
      'Fabric Color': visibleFabricColor,
      _headboard_heights: headboardSelection ? String(headboardSelection.title || '') : '',
      _headboard_price: headboardSelection ? this.formatMoney(headboardPriceCents) : '',
      _delivery_option: deliverySelection ? String(deliverySelection.title || '') : '',
      _delivery_price: deliverySelection ? this.formatMoney(deliveryPriceCents) : '',
      _storage_product: storageSelection ? String(storageSelection.title || '') : '',
      _storage_price: storageSelection ? this.formatMoney(storagePriceCents) : ''
    };

    if (this.selectedAddon) {
      mainItemProperties._variant_add_on = addonTitle;
      mainItemProperties._add_on_price = addonPriceLabel;
    }
    // Nested cart line functionality end

    const bundlePayload = {
      items: [
        {
          id: Number(this.currentVariant.id),
          quantity: 1,
          properties: mainItemProperties
        }
      ]
    };

    if (linkedVariant) {
      bundlePayload.items.push({
        id: Number(linkedVariant.id),
        quantity: 1,
        parent_id: parentVariantId,
        properties: { 
          _child: '1',
          _linked_variant_title: String(linkedVariant.title || '')
        }
      });
    }

    const storageCartItem = this.getSelectedStorageCartItem(parentVariantId);
    if (storageCartItem) {
      bundlePayload.items.push(storageCartItem);
    }

    const headboardCartItem = this.getSelectedHeadboardCartItem(parentVariantId);
    if (headboardCartItem) {
      bundlePayload.items.push(headboardCartItem);
    }

    const deliveryCartItem = this.getSelectedDeliveryCartItem(parentVariantId);
    if (deliveryCartItem) {
      bundlePayload.items.push(deliveryCartItem);
    }

    // Nested cart line functionality start
    childItemsForPayload.forEach((child) => {
      bundlePayload.items.push({
        id: Number(child.variantId),
        quantity: 1,
        parent_id: parentVariantId,
        properties: { _child: '1' }
      });
    });
    // Nested cart line functionality end

    this.logBundleDebug('cart-add-payload', bundlePayload);

    const endpoint = window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add.js';

    try {
      const response = await fetch(endpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        credentials: 'same-origin',
        body: JSON.stringify(bundlePayload)
      });

      if (!response.ok) {
        let errorBody = null;
        try {
          errorBody = await response.json();
        } catch (jsonError) {
          errorBody = { message: 'unable to parse error json' };
        }
        this.logBundleDebug('cart-add-failed', {
          status: response.status,
          body: errorBody
        });
        throw new Error('Cart add failed');
      }

      const addedResponse = await response.json();
      this.logBundleDebug('cart-add-success-item', addedResponse);

      // Nested cart line functionality start
      // Children were included in the same payload — just reset their checkboxes.
      if (this.childProductsRoot && childItemsForPayload.length > 0) {
        this.childProductsRoot.querySelectorAll('[data-child-checkbox]').forEach((cb) => {
          cb.checked = false;
        });
        this.selectedChildItems = [];
      }
      // Nested cart line functionality end

      // Nested cart line functionality start
      this.logBundleDebug('nested-cart-lines-added', {
        parentVariantId,
        totalPayloadItems: bundlePayload.items.length,
        childAddOnCount: childItemsForPayload.length,
        fabricSelection
      });
      // Nested cart line functionality end

      this.openCartSidebar();
      this.section.dispatchEvent(new CustomEvent('cart:item-added', {
        bubbles: true,
        detail: {
          mainVariantId: this.currentVariant.id,
          linkedVariantId: linkedVariant.id,
          storageVariantId: storageSelection ? storageSelection.variantId : null
        }
      }));
    } catch (error) {
      if (window.console && typeof window.console.error === 'function') {
        console.error(error);
      }
    } finally {
      this.updateButtonState();
      if (submitButton) {
        submitButton.classList.remove('loading');
        submitButton.removeAttribute('aria-busy');
      }
    }
  }

  openCartSidebar() {
    const sidebar = document.querySelector('#halo-cart-sidebar');
    if (!sidebar) return;

    document.body.classList.add('cart-sidebar-show');

    if (
      window.Shopify &&
      typeof window.Shopify.getCart === 'function' &&
      window.sharedFunctions &&
      typeof window.sharedFunctions.updateSidebarCart === 'function'
    ) {
      window.Shopify.getCart((cart) => {
        this.logBundleDebug('sidebar-cart-refresh', {
          itemCount: cart && typeof cart.item_count !== 'undefined' ? cart.item_count : null
        });
        window.sharedFunctions.updateSidebarCart(cart);
      });
    }
  }

  logBundleDebug(label, payload = null) {
    if (!this.debugBundle) return;
    if (payload === null) {
      console.log('[bundle-debug]', label);
      return;
    }
    console.log('[bundle-debug]', label, payload);
  }

  formatMoney(value) {
    const amount = Number(value);
    const safeAmount = Number.isFinite(amount) ? amount : 0;
    const moneyFormat = window.theme && window.theme.moneyFormat ? window.theme.moneyFormat : '£{{amount}}';

    if (window.Shopify && window.Shopify.formatMoney) {
      return window.Shopify.formatMoney(safeAmount, moneyFormat);
    }

    return `${(safeAmount / 100).toFixed(2)}`;
  }

  escapeHTML(value) {
    return String(value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  syncSliderWithVariant() {
    if (!this.currentVariant || !this.currentVariant.featured_media || !this.slides.length) return;
    const mediaId = String(this.currentVariant.featured_media.id);
    const index = this.slides.findIndex((slide) => String(slide.dataset.mediaId) === mediaId);

    if (index > -1) {
      this.showSlide(index);
    }
  }

  showSlide(index) {
    if (!this.slides.length) return;

    this.currentSlideIndex = index;

    this.slides.forEach((slide, slideIndex) => {
      slide.classList.toggle('is-active', slideIndex === index);
    });

    this.thumbs.forEach((thumb, thumbIndex) => {
      thumb.classList.toggle('is-active', thumbIndex === index);
    });

    this.dots.forEach((dot, dotIndex) => {
      dot.classList.toggle('is-active', dotIndex === index);
    });

    const activeThumb = this.thumbs[index];
    if (activeThumb && this.thumbsContainer) {
      const thumbLeft = activeThumb.offsetLeft;
      const thumbWidth = activeThumb.offsetWidth;
      const containerWidth = this.thumbsContainer.offsetWidth;
      const scrollTarget = thumbLeft - (containerWidth / 2) + (thumbWidth / 2);
      this.thumbsContainer.scrollTo({
        left: scrollTarget,
        behavior: 'smooth'
      });
    }
  }

  setActiveTab(targetKey) {
    const triggers = [...this.section.querySelectorAll('[data-config-tab-trigger]')];
    const panels = [...this.section.querySelectorAll('[data-config-tab-panel]')];

    panels.forEach((panel) => {
      const panelKey = panel.dataset.configTabPanel;
      const isActive = (panelKey === targetKey) || (targetKey === 'linked-variants' && panelKey === 'size');
      panel.hidden = !isActive;
    });

    triggers.forEach((trigger) => {
      const isActive = trigger.dataset.configTabTarget === targetKey;
      trigger.classList.toggle('is-active', isActive);
      trigger.setAttribute('aria-expanded', isActive ? 'true' : 'false');
      if (isActive && typeof trigger.scrollIntoView === 'function') {
        trigger.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
      }
    });

    const sizePanel = this.section.querySelector('[data-config-tab-panel="size"]');
    if (sizePanel) {
      const sizeOptionsList = sizePanel.querySelectorAll('.custom-variant-options');
      const sizeGroups = sizePanel.querySelectorAll('.custom-variant-group:not(.linked-product-variants-wrap)');
      const linkedWrap = this.linkedVariantsWrap;
      const linkedTitle = this.linkedVariantsTitle;
      const linkedContainer = this.linkedVariantsContainer;

      if (targetKey === 'size') {
        sizeOptionsList.forEach(el => {
          el.style.display = '';
          el.hidden = false;
        });
        sizeGroups.forEach(el => {
          el.style.display = '';
          el.hidden = false;
        });
        if (linkedWrap) {
          linkedWrap.style.display = 'none';
          linkedWrap.hidden = true;
        }
        if (linkedTitle) {
          linkedTitle.style.display = 'none';
          linkedTitle.hidden = true;
        }
        if (linkedContainer) {
          linkedContainer.style.display = 'none';
          linkedContainer.hidden = true;
        }
      } else if (targetKey === 'linked-variants') {
        sizeOptionsList.forEach(el => {
          el.style.display = 'none';
          el.hidden = true;
        });
        sizeGroups.forEach(el => {
          el.style.display = 'none';
          el.hidden = true;
        });
        if (linkedWrap) {
          linkedWrap.style.display = 'block';
          linkedWrap.hidden = false;
        }
        if (linkedTitle) {
          linkedTitle.style.display = 'none';
          linkedTitle.hidden = true;
        }
        if (linkedContainer) {
          linkedContainer.style.display = '';
          linkedContainer.hidden = false;
        }
      }
    }

    const fabricPanel = this.section.querySelector('[data-config-tab-panel="fabric"]');
    if (fabricPanel) {
      const fabricBlockList = fabricPanel.querySelector('.fabric-block-list');
      const fabricColorListWrap = fabricPanel.querySelector('.fabric-color-list-wrap');
      const activeBlock = fabricPanel.querySelector('.fabric-block.fabric-active');
      const activeIndex = activeBlock ? activeBlock.dataset.fabricIndex : 'same-as-main';

      const dynamicFabricTab = this.section.querySelector('[data-config-tab-trigger][data-config-tab-target="fabric-selection"]');
      if (dynamicFabricTab) {
        dynamicFabricTab.remove();
      }

      if (fabricBlockList) {
        fabricBlockList.style.display = '';
        fabricBlockList.hidden = false;
      }
      if (fabricColorListWrap) {
        const showColors = activeIndex && activeIndex !== 'same-as-main';
        fabricColorListWrap.style.display = showColors ? '' : 'none';
        fabricColorListWrap.hidden = !showColors;
      }
    }
  }

  setConfigTabContent(button, iconType, text) {
    button.textContent = '';
    const inner = document.createElement('span');
    inner.className = 'custom-config-tab-inner';
    const icon = document.createElement('span');
    icon.className = 'custom-config-tab-icon';
    icon.innerHTML = CONFIG_TAB_ICONS[iconType] || '';
    const label = document.createElement('span');
    label.className = 'custom-config-tab-text';
    label.textContent = text;
    inner.append(icon, label);
    button.append(inner);
  }

  updateOrCreateDynamicTab(titleText) {
    const sizeTab = this.section.querySelector('[data-config-tab-trigger][data-config-tab-target="size"]');
    if (!sizeTab) return;

    let dynamicTab = this.section.querySelector('[data-config-tab-trigger][data-config-tab-target="linked-variants"]');
    if (dynamicTab) {
      this.setConfigTabContent(dynamicTab, 'bed', titleText);
    } else {
      dynamicTab = document.createElement('button');
      dynamicTab.type = 'button';
      dynamicTab.className = 'custom-config-tab-trigger';
      dynamicTab.setAttribute('data-config-tab-trigger', '');
      dynamicTab.setAttribute('data-config-tab-target', 'linked-variants');
      dynamicTab.setAttribute('aria-expanded', 'false');
      this.setConfigTabContent(dynamicTab, 'bed', titleText);
      sizeTab.after(dynamicTab);
    }
  }

  updateOrCreateFabricTab(fabricName, fabricIndex) {
    // Dynamic fabric tab is removed; colors display directly under fabric row
    const dynamicFabricTab = this.section.querySelector('[data-config-tab-trigger][data-config-tab-target="fabric-selection"]');
    if (dynamicFabricTab) {
      dynamicFabricTab.remove();
    }
  }

  initConfigTabs() {
    this.tabNav = this.section.querySelector('.custom-config-tab-nav');
    if (!this.tabNav) return;

    this.tabNav.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-config-tab-trigger]');
      if (!trigger) return;
      const targetKey = trigger.dataset.configTabTarget;
      if (!targetKey) return;
      this.setActiveTab(targetKey);
    });

    const summaryContainer = this.section.querySelector('[data-config-summary]');
    if (summaryContainer && !summaryContainer._chipListenerAttached) {
      summaryContainer._chipListenerAttached = true;
      summaryContainer.addEventListener('click', (event) => {
        const chip = event.target.closest('[data-chip-tab]');
        if (!chip) return;
        const targetTab = chip.dataset.chipTab;
        if (targetTab) {
          this.setActiveTab(targetTab);
        }
      });
    }

    const sizeTrigger = this.tabNav.querySelector('[data-config-tab-trigger][data-config-tab-target="size"]');
    if (sizeTrigger) {
      this.setActiveTab('size');
    } else {
      const activeTrigger = this.tabNav.querySelector('[data-config-tab-trigger].is-active') || this.tabNav.querySelector('[data-config-tab-trigger]');
      if (activeTrigger) {
        const defaultKey = activeTrigger.dataset.configTabTarget;
        if (defaultKey) {
          this.setActiveTab(defaultKey);
        }
      }
    }
  }

  updateSummaryChips() {
    const chipsContainer = this.section.querySelector('[data-config-summary-chips]');
    if (!chipsContainer) return;

    const chips = [];

    // Tab 1: Size
    if (this.mainVariantSelected && this.currentVariant) {
      chips.push({
        tab: 'size',
        label: this.currentVariant.title
      });
    }

    // Tab 2: Mattress (Linked Variant)
    const linkedVariant = this.getSelectedLinkedVariant();
    if (linkedVariant && linkedVariant.title) {
      chips.push({
        tab: 'linked-variants',
        label: linkedVariant.title
      });
    }

    // Tab 2: Fabric & Colour
    const fabricSelection = this.getActiveFabricSelection();
    if (fabricSelection) {
      let label = '';
      if (fabricSelection.sameAsMain) {
        label = 'Same as Main Image';
      } else if (fabricSelection.fabricColorName) {
        const cleanColorName = fabricSelection.fabricColorName.replace(/\s*\([^)]*\)/g, '').trim();
        const cleanFabricName = fabricSelection.fabricName.replace(/\s*\([^)]*\)/g, '').trim();
        label = cleanColorName ? `${cleanFabricName} - ${cleanColorName}` : cleanFabricName;
      } else if (fabricSelection.fabricName) {
        label = fabricSelection.fabricName.replace(/\s*\([^)]*\)/g, '').trim();
      }
      if (label) {
        chips.push({
          tab: 'fabric',
          label
        });
      }
    }

    // Tab 3: Storage Options
    if (this.selectedStorage && this.selectedStorage.title) {
      chips.push({
        tab: 'storage',
        label: this.selectedStorage.title
      });
    }

    // Tab 4: Headboard Height
    if (this.selectedHeadboard && this.selectedHeadboard.title) {
      chips.push({
        tab: 'headboard',
        label: this.selectedHeadboard.title
      });
    }

    chipsContainer.innerHTML = chips
      .map(
        (chip) => `
        <button type="button" class="custom-summary-chip" data-chip-tab="${this.escapeHTML(chip.tab)}">
          <span class="custom-summary-chip-icon" aria-hidden="true">✓</span>
          <span class="custom-summary-chip-text">${this.escapeHTML(chip.label)}</span>
        </button>`
      )
      .join('');
  }

  initAccordion() {
    const items = [...this.section.querySelectorAll('[data-accordion-item]')];
    const triggers = [...this.section.querySelectorAll('[data-accordion-trigger]')];
    if (!items.length || !triggers.length) return;

    const setActiveItem = (targetKey) => {
      let hasMatch = false;

      items.forEach((item) => {
        const isActive = item.dataset.accordionItem === targetKey;
        item.classList.toggle('is-open', isActive);
        if (isActive) hasMatch = true;
      });

      triggers.forEach((trigger) => {
        const isActive = trigger.dataset.accordionTarget === targetKey;
        trigger.classList.toggle('is-active', isActive);
        trigger.setAttribute('aria-expanded', isActive ? 'true' : 'false');
      });

      return hasMatch;
    };

    const defaultKey =
      items.find((item) => item.classList.contains('is-open'))?.dataset.accordionItem ||
      triggers[0].dataset.accordionTarget;

    setActiveItem(defaultKey);

    triggers.forEach((trigger) => {
      trigger.addEventListener('click', () => {
        const targetKey = trigger.dataset.accordionTarget;
        if (!targetKey) return;
        setActiveItem(targetKey);
      });
    });
  }

  updateActiveSlideImage(imageUrl) {
    const activeSlide = this.section.querySelector('.custom-slide.is-active');
    if (!activeSlide) return;

    const slideImage = activeSlide.querySelector('.custom-slide-image');
    if (slideImage && slideImage.tagName === 'IMG') {
      slideImage.src = imageUrl;
      slideImage.removeAttribute('srcset');
    }
  }

  initSizeChartPopup() {
    const sizeChartButton = this.section.querySelector('#custom-size-chart');
    const sizeChartPopup = this.section.querySelector('#size-chart-popup');
    const sizeChartClose = this.section.querySelector('#size-chart-close');
    const sizeChartOverlay = this.section.querySelector('.size-chart-popup-overlay');

    if (!sizeChartButton || !sizeChartPopup) return;

    // Portal to <body> so the modal isn't trapped under the sticky header's stacking context
    if (sizeChartPopup.parentElement !== document.body) {
      document.body.appendChild(sizeChartPopup);
    }

    const openPopup = () => {
      sizeChartPopup.hidden = false;
      document.body.style.overflow = 'hidden';
    };

    const closePopup = () => {
      sizeChartPopup.hidden = true;
      document.body.style.overflow = '';
    };

    sizeChartButton.addEventListener('click', openPopup);

    if (sizeChartClose) {
      sizeChartClose.addEventListener('click', closePopup);
    }

    if (sizeChartOverlay) {
      sizeChartOverlay.addEventListener('click', closePopup);
    }

    // Close on escape key
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && !sizeChartPopup.hidden) {
        closePopup();
      }
    });
  }

  initLightbox() {
    const lightbox = this.section.querySelector('#custom-lightbox');
    const lightboxImage = this.section.querySelector('#lightbox-image');
    const lightboxClose = this.section.querySelector('#lightbox-close');
    const lightboxPrev = this.section.querySelector('#lightbox-prev');
    const lightboxNext = this.section.querySelector('#lightbox-next');
    const lightboxOverlay = this.section.querySelector('.custom-lightbox-overlay');
    const lightboxCurrent = this.section.querySelector('#lightbox-current');
    const lightboxTotal = this.section.querySelector('#lightbox-total');
    const sliderMain = this.section.querySelector('.custom-slider-main');

    if (!lightbox || !lightboxImage || !sliderMain) return;

    // Portal to <body> so the lightbox isn't trapped under the sticky header's stacking context
    if (lightbox.parentElement !== document.body) {
      document.body.appendChild(lightbox);
    }

    const slides = [...sliderMain.querySelectorAll('[data-slide]')];
    let currentIndex = 0;

    const updateLightboxImage = (index) => {
      const slide = slides[index];
      if (!slide) return;

      const slideImage = slide.querySelector('.custom-slide-image');
      if (slideImage) {
        lightboxImage.src = slideImage.src;
        lightboxImage.alt = slideImage.alt || '';
      }

      if (lightboxCurrent) {
        lightboxCurrent.textContent = index + 1;
      }

      if (lightboxTotal) {
        lightboxTotal.textContent = slides.length;
      }
    };

    const openLightbox = (index) => {
      currentIndex = index;
      updateLightboxImage(currentIndex);
      lightbox.hidden = false;
      document.body.style.overflow = 'hidden';
    };

    const closeLightbox = () => {
      lightbox.hidden = true;
      document.body.style.overflow = '';
    };

    const goToNext = () => {
      currentIndex = (currentIndex + 1) % slides.length;
      updateLightboxImage(currentIndex);
    };

    const goToPrev = () => {
      currentIndex = (currentIndex - 1 + slides.length) % slides.length;
      updateLightboxImage(currentIndex);
    };

    // Add click events to slides
    slides.forEach((slide, index) => {
      slide.addEventListener('click', () => {
        openLightbox(index);
      });
      slide.style.cursor = 'pointer';
    });

    const expandBtn = this.section.querySelector('[data-slider-expand]');
    if (expandBtn) {
      expandBtn.addEventListener('click', (e) => {
        e.stopPropagation();
        openLightbox(this.currentSlideIndex);
      });
    }

    // Close button
    if (lightboxClose) {
      lightboxClose.addEventListener('click', closeLightbox);
    }

    // Overlay click to close
    if (lightboxOverlay) {
      lightboxOverlay.addEventListener('click', closeLightbox);
    }

    // Navigation buttons
    if (lightboxNext) {
      lightboxNext.addEventListener('click', (e) => {
        e.stopPropagation();
        goToNext();
      });
    }

    if (lightboxPrev) {
      lightboxPrev.addEventListener('click', (e) => {
        e.stopPropagation();
        goToPrev();
      });
    }

    // Keyboard navigation
    document.addEventListener('keydown', (event) => {
      if (lightbox.hidden) return;

      if (event.key === 'Escape') {
        closeLightbox();
      } else if (event.key === 'ArrowRight') {
        goToNext();
      } else if (event.key === 'ArrowLeft') {
        goToPrev();
      }
    });

    // Touch swipe support
    let touchStartX = 0;
    let touchEndX = 0;

    lightbox.addEventListener('touchstart', (e) => {
      touchStartX = e.changedTouches[0].screenX;
    }, { passive: true });

    lightbox.addEventListener('touchend', (e) => {
      touchEndX = e.changedTouches[0].screenX;
      handleSwipe();
    }, { passive: true });

    const handleSwipe = () => {
      const swipeThreshold = 50;
      const diff = touchStartX - touchEndX;

      if (Math.abs(diff) > swipeThreshold) {
        if (diff > 0) {
          goToNext();
        } else {
          goToPrev();
        }
      }
    };
  }

  initColorsLightbox() {
    console.log('[Colors Lightbox] Initializing...');
    console.log('[Colors Lightbox] Section HTML contains colors-lightbox:', this.section.innerHTML.includes('colors-lightbox'));
    
    const colorDetailsButton = this.section.querySelector('#color-details__button');
    const colorsLightbox = this.section.querySelector('#colors-lightbox');
    const colorsImagesScript = this.section.querySelector('[data-colors-images]');
    
    console.log('[Colors Lightbox] Elements found:', {
      colorDetailsButton: !!colorDetailsButton,
      colorsLightbox: !!colorsLightbox,
      colorsImagesScript: !!colorsImagesScript
    });
    
    if (!colorDetailsButton || !colorsLightbox || !colorsImagesScript) {
      console.log('[Colors Lightbox] Missing required elements, aborting');
      console.log('[Colors Lightbox] Section ID:', this.section.id);
      return;
    }

    const colorsImages = this.parseJSONScript(colorsImagesScript, []);
    console.log('[Colors Lightbox] Colors images array:', colorsImages);
    if (!colorsImages.length) {
      console.log('[Colors Lightbox] No colors images found, aborting');
      return;
    }

    const lightboxImage = this.section.querySelector('#colors-lightbox-image');
    const lightboxClose = this.section.querySelector('#colors-lightbox-close');
    const lightboxPrev = this.section.querySelector('#colors-lightbox-prev');
    const lightboxNext = this.section.querySelector('#colors-lightbox-next');
    const lightboxOverlay = this.section.querySelector('[data-colors-lightbox-overlay]');
    const lightboxCurrent = this.section.querySelector('#colors-lightbox-current');
    const lightboxTotal = this.section.querySelector('#colors-lightbox-total');

    // Portal to <body> so the fabric/colour lightbox isn't trapped under the sticky header's stacking context
    if (colorsLightbox.parentElement !== document.body) {
      document.body.appendChild(colorsLightbox);
    }

    let currentIndex = 0;

    const updateLightboxImage = (index) => {
      if (index >= 0 && index < colorsImages.length) {
        lightboxImage.src = colorsImages[index];
        lightboxImage.alt = 'Color image ' + (index + 1);

        if (lightboxCurrent) {
          lightboxCurrent.textContent = index + 1;
        }

        if (lightboxTotal) {
          lightboxTotal.textContent = colorsImages.length;
        }
      }
    };

    const openLightbox = (startIndex = 0) => {
      currentIndex = startIndex >= 0 && startIndex < colorsImages.length ? startIndex : 0;
      updateLightboxImage(currentIndex);
      colorsLightbox.hidden = false;
      document.body.classList.add('colors-lightbox-open');
      lightboxClose.focus();
    };

    const closeLightbox = () => {
      colorsLightbox.hidden = true;
      document.body.classList.remove('colors-lightbox-open');
      colorDetailsButton.focus();
    };

    const goToNext = () => {
      currentIndex = (currentIndex + 1) % colorsImages.length;
      updateLightboxImage(currentIndex);
    };

    const goToPrev = () => {
      currentIndex = (currentIndex - 1 + colorsImages.length) % colorsImages.length;
      updateLightboxImage(currentIndex);
    };

    // Open lightbox when color details button is clicked
    colorDetailsButton.addEventListener('click', () => {
      console.log('[Colors Lightbox] Button clicked');
      // Try to find currently selected fabric and color to determine starting index
      const activeFabric = this.section.querySelector('.fabric-block.fabric-active');
      const activeColor = this.section.querySelector('.fabric-color-item.fabric-color-item-active');
      
      console.log('[Colors Lightbox] Active elements:', {
        activeFabric: !!activeFabric,
        activeColor: !!activeColor
      });
      
      let startIndex = 0;
      
      if (activeFabric && activeColor) {
        const fabricIndex = parseInt(activeFabric.dataset.fabricIndex);
        const colorName = activeColor.dataset.color;
        
        console.log('[Colors Lightbox] Selected fabric/color:', { fabricIndex, colorName });
        
        // Calculate the starting index based on fabric and color selection
        let imageCount = 0;
        let found = false;
        
        const fabricBlocks = this.section.querySelectorAll('.fabric-block');
        fabricBlocks.forEach((fabric, fIndex) => {
          const colorList = this.section.querySelector(`.fabric-color-list[data-fabric-index="${fIndex}"]`);
          if (colorList) {
            const colorItems = colorList.querySelectorAll('.fabric-color-item');
            colorItems.forEach((colorItem) => {
              if (!found) {
                if (fIndex === fabricIndex && colorItem.dataset.color === colorName) {
                  startIndex = imageCount;
                  found = true;
                }
                imageCount++;
              }
            });
          }
        });
        
        console.log('[Colors Lightbox] Calculated start index:', startIndex);
      }
      
      console.log('[Colors Lightbox] Opening lightbox with index:', startIndex);
      openLightbox(startIndex);
    });

    // Close button
    if (lightboxClose) {
      lightboxClose.addEventListener('click', closeLightbox);
    }

    // Overlay click to close
    if (lightboxOverlay) {
      lightboxOverlay.addEventListener('click', closeLightbox);
    }

    // Navigation buttons
    if (lightboxNext) {
      lightboxNext.addEventListener('click', (e) => {
        e.stopPropagation();
        goToNext();
      });
    }

    if (lightboxPrev) {
      lightboxPrev.addEventListener('click', (e) => {
        e.stopPropagation();
        goToPrev();
      });
    }

    // Keyboard navigation
    document.addEventListener('keydown', (event) => {
      if (colorsLightbox.hidden) return;

      if (event.key === 'Escape') {
        closeLightbox();
      } else if (event.key === 'ArrowRight') {
        goToNext();
      } else if (event.key === 'ArrowLeft') {
        goToPrev();
      }
    });

    // Touch swipe support
    let touchStartX = 0;
    let touchEndX = 0;

    colorsLightbox.addEventListener('touchstart', (e) => {
      touchStartX = e.changedTouches[0].screenX;
    }, { passive: true });

    colorsLightbox.addEventListener('touchend', (e) => {
      touchEndX = e.changedTouches[0].screenX;
      handleSwipe();
    }, { passive: true });

    const handleSwipe = () => {
      const swipeThreshold = 50;
      const diff = touchStartX - touchEndX;

      if (Math.abs(diff) > swipeThreshold) {
        if (diff > 0) {
          goToNext();
        } else {
          goToPrev();
        }
      }
    };
  }

  initFabricSelection() {
    const colorSelection = this.section.querySelector('.custom-color-selection');
    if (!colorSelection) return;

    const fabricBlocks = [...colorSelection.querySelectorAll('.fabric-block')];
    const fabricColorLists = [...colorSelection.querySelectorAll('.fabric-color-list')];
    const fabricColorItems = [...colorSelection.querySelectorAll('.fabric-color-item')];
    if (!fabricBlocks.length) return;

    const clearColorItemState = () => {
      fabricColorItems.forEach((item) => {
        item.classList.remove('fabric-color-item-active');
      });
    };

    const updateColorListWrapVisibility = (idx) => {
      const fabricColorListWrap = colorSelection.querySelector('.fabric-color-list-wrap');
      if (fabricColorListWrap) {
        const showColors = Boolean(idx && idx !== 'same-as-main');
        fabricColorListWrap.style.display = showColors ? '' : 'none';
        fabricColorListWrap.hidden = !showColors;
      }
    };

    const activateByIndex = (activeIndex) => {
      fabricBlocks.forEach((block) => {
        const isActive = activeIndex && block.dataset.fabricIndex === activeIndex;
        block.classList.toggle('fabric-active', isActive);
      });

      fabricColorLists.forEach((list) => {
        const isActive = activeIndex && list.dataset.fabricIndex === activeIndex;
        list.classList.toggle('fabric-active', isActive);
      });

      clearColorItemState();
      updateColorListWrapVisibility(activeIndex);
    };

    // Preselect first available fabric block if none selected
    let activeBlock = fabricBlocks.find((block) => block.classList.contains('fabric-active'));
    if (!activeBlock) {
      activeBlock = fabricBlocks[0];
      if (activeBlock) {
        const activeIndex = activeBlock.dataset.fabricIndex;
        activateByIndex(activeIndex);
        if (activeIndex !== 'same-as-main') {
          const matchingList = colorSelection.querySelector(`.fabric-color-list[data-fabric-index="${activeIndex}"]`);
          if (matchingList) {
            const firstColor = matchingList.querySelector('.fabric-color-item');
            if (firstColor) firstColor.classList.add('fabric-color-item-active');
          }
        }
      }
    } else {
      const activeIndex = activeBlock.dataset.fabricIndex;
      updateColorListWrapVisibility(activeIndex);
      if (activeIndex !== 'same-as-main') {
        const matchingList = colorSelection.querySelector(`.fabric-color-list[data-fabric-index="${activeIndex}"]`);
        if (matchingList) {
          const hasActiveColor = matchingList.querySelector('.fabric-color-item.fabric-color-item-active');
          if (!hasActiveColor) {
            const firstColor = matchingList.querySelector('.fabric-color-item');
            if (firstColor) firstColor.classList.add('fabric-color-item-active');
          }
        }
      }
    }

    if (!colorSelection._fabricListenerAttached) {
      colorSelection._fabricListenerAttached = true;
      colorSelection.addEventListener('click', (event) => {
        const clickedColorItem = event.target.closest('.fabric-color-item');
        if (clickedColorItem && colorSelection.contains(clickedColorItem)) {
          clearColorItemState();
          clickedColorItem.classList.add('fabric-color-item-active');
          this.updateSummaryChips();
          this.updateButtonState();
          return;
        }

        const clickedBlock = event.target.closest('.fabric-block');
        if (!clickedBlock || !colorSelection.contains(clickedBlock)) return;

        const activeIndex = clickedBlock.dataset.fabricIndex;
        activateByIndex(activeIndex);

        if (activeIndex !== 'same-as-main') {
          const matchingList = colorSelection.querySelector(`.fabric-color-list[data-fabric-index="${activeIndex}"]`);
          if (matchingList) {
            const firstColor = matchingList.querySelector('.fabric-color-item');
            if (firstColor) {
              firstColor.classList.add('fabric-color-item-active');
            }
          }
        }

        // Update active slide with fabric image
        const fabricImageUrl = clickedBlock.dataset.fabricImage;
        if (fabricImageUrl) {
          this.updateActiveSlideImage(fabricImageUrl);
        }

        // Clean up any dynamic fabric tab if present
        const dynamicFabricTab = this.section.querySelector('[data-config-tab-trigger][data-config-tab-target="fabric-selection"]');
        if (dynamicFabricTab) {
          dynamicFabricTab.remove();
        }

        this.updateSummaryChips();
        this.updateButtonState();
      });
    }

    this.updateSummaryChips();
    this.updateButtonState();
  }

  initStorageSelection() {
    if (!this.storageProductCards.length) return;

    let selected = null;
    for (const card of this.storageProductCards) {
      const productId = String(card.dataset.storageProductId || '');
      const hasVariants = String(card.dataset.storageHasVariants || '') === 'true';

      if (hasVariants) {
        const variantButtons = [...card.querySelectorAll('[data-storage-variant-option]')];
        const firstAvailVariant = variantButtons.find((btn) => !btn.disabled);
        if (firstAvailVariant) {
          const varTitle = String(firstAvailVariant.dataset.storageVariantTitle || '');
          const cardTitle = String(card.dataset.storageProductTitle || '');
          const title = (cardTitle && varTitle && varTitle !== 'Default Title')
            ? `${cardTitle} - ${varTitle}`
            : (varTitle && varTitle !== 'Default Title' ? varTitle : cardTitle);
          selected = {
            productId,
            variantId: String(firstAvailVariant.dataset.storageVariantId || ''),
            title: title || cardTitle,
            price: Number(firstAvailVariant.dataset.storageVariantPrice || 0)
          };
          this.activeStorageProductId = productId;
          break;
        }
      } else {
        const defaultVariantId = String(card.dataset.storageDefaultVariantId || '');
        if (defaultVariantId) {
          selected = {
            productId,
            variantId: defaultVariantId,
            title: String(card.dataset.storageProductTitle || ''),
            price: Number(card.dataset.storageDefaultPrice || 0)
          };
          this.activeStorageProductId = productId;
          break;
        }
      }
    }

    this.selectedStorage = selected;
    this.setStorageSelectionError(false);
    this.updateStorageSelectionState();
    this.updatePrice();
    this.updateButtonState();
    this.updateSummaryChips();
  }

  initHeadboardSelection() {
    if (!this.headboardRoot && !this.headboardSelect) return;

    let selected = null;
    if (this.headboardCards && this.headboardCards.length) {
      const firstAvailableCard = this.headboardCards.find((card) => card.dataset.headboardUnavailable !== 'true');
      if (firstAvailableCard) {
        selected = {
          variantId: String(firstAvailableCard.dataset.headboardVariantId || ''),
          title: String(firstAvailableCard.dataset.headboardVariantTitle || ''),
          price: Number(firstAvailableCard.dataset.headboardVariantPrice || 0)
        };
      }
    }

    if (!selected && this.headboardSelect) {
      const firstAvailableOption = [...this.headboardSelect.options].find((opt) => opt.value && !opt.disabled);
      if (firstAvailableOption) {
        selected = {
          variantId: String(firstAvailableOption.value),
          title: String(firstAvailableOption.dataset.headboardVariantTitle || firstAvailableOption.textContent || '').trim(),
          price: Number(firstAvailableOption.dataset.headboardVariantPrice || 0)
        };
      }
    }

    this.selectedHeadboard = selected;
    if (this.headboardSelect && selected) {
      this.headboardSelect.value = selected.variantId;
    }

    this.updateHeadboardCardState();
    this.setHeadboardSelectionError(false);
    this.updateHeadboardLineItemProperties();
    this.updatePrice();
    this.updateButtonState();
    this.updateSummaryChips();
  }

  handleHeadboardSelectionClick(event) {
    const trigger = event.target.closest('[data-headboard-trigger]');
    if (!trigger || !this.headboardRoot || !this.headboardRoot.contains(trigger)) return;

    const card = trigger.closest('[data-headboard-card]');
    if (!card || card.dataset.headboardUnavailable === 'true') return;

    const variantId = String(card.dataset.headboardVariantId || '');
    const title = String(card.dataset.headboardVariantTitle || '');
    const price = Number(card.dataset.headboardVariantPrice || 0);

    this.selectedHeadboard = {
      variantId,
      title,
      price
    };

    if (this.headboardSelect) {
      this.headboardSelect.value = variantId;
    }

    this.updateHeadboardCardState();
    this.setHeadboardSelectionError(false);
    this.updateHeadboardLineItemProperties();
    this.updatePrice();
    this.updateButtonState();
    this.updateSummaryChips();

    this.logBundleDebug('headboard-card-selected', {
      selectedHeadboard: this.selectedHeadboard,
      productId: this.headboardRoot ? String(this.headboardRoot.dataset.headboardProductId || '') : '',
      productTitle: this.headboardRoot ? String(this.headboardRoot.dataset.headboardProductTitle || '') : ''
    });
  }

  updateHeadboardCardState() {
    if (!this.headboardCards || !this.headboardCards.length) return;

    const selectedVariantId = this.selectedHeadboard ? String(this.selectedHeadboard.variantId || '') : '';

    this.headboardCards.forEach((card) => {
      const cardVariantId = String(card.dataset.headboardVariantId || '');
      const isActive = Boolean(selectedVariantId && cardVariantId === selectedVariantId);
      card.classList.toggle('is-active', isActive);

      const trigger = card.querySelector('[data-headboard-trigger]');
      if (trigger) {
        trigger.setAttribute('aria-pressed', String(isActive));
      }
    });
  }

  handleHeadboardSelectionChange() {
    if (!this.headboardSelect) return;

    const selectedOption = this.headboardSelect.options[this.headboardSelect.selectedIndex];
    const variantId = this.headboardSelect.value ? String(this.headboardSelect.value) : '';

    this.logBundleDebug('headboard-dropdown-change', {
      rawValue: this.headboardSelect.value,
      selectedIndex: this.headboardSelect.selectedIndex,
      selectedText: selectedOption ? String(selectedOption.textContent || '').trim() : ''
    });

    if (!variantId || !selectedOption) {
      this.selectedHeadboard = null;
      this.updateHeadboardCardState();
      this.setHeadboardSelectionError(true);
      this.logBundleDebug('headboard-selection-cleared', {
        selectedHeadboard: this.selectedHeadboard
      });
      this.updateHeadboardLineItemProperties();
      this.updatePrice();
      this.updateButtonState();
      this.updateSummaryChips();
      return;
    }

    this.selectedHeadboard = {
      variantId,
      title: String(selectedOption.dataset.headboardVariantTitle || selectedOption.textContent || '').trim(),
      price: Number(selectedOption.dataset.headboardVariantPrice || 0)
    };

    this.logBundleDebug('headboard-selection-updated', {
      selectedHeadboard: this.selectedHeadboard,
      productId: this.headboardRoot ? String(this.headboardRoot.dataset.headboardProductId || '') : '',
      productTitle: this.headboardRoot ? String(this.headboardRoot.dataset.headboardProductTitle || '') : ''
    });

    this.updateHeadboardCardState();
    this.setHeadboardSelectionError(false);
    this.updateHeadboardLineItemProperties();
    this.updatePrice();
    this.updateButtonState();
    this.updateSummaryChips();
  }

  initDeliverySelection() {
    if (!this.deliverySelect) return;

    this.selectedDelivery = null;
    this.deliverySelect.value = '';
    this.setDeliverySelectionError(false);
    this.updateDeliveryLineItemProperties();
    this.updateDeliveryCardState();
  }

  toggleDeliveryCardSelection() {
    if (!this.deliverySelect) return;
    const btn = this.deliveryToggleBtn || (this.deliveryRoot ? this.deliveryRoot.querySelector('[data-delivery-toggle-btn]') : null);
    const card = this.deliveryCard || (this.deliveryRoot ? this.deliveryRoot.querySelector('[data-delivery-card]') : null);
    const variantId = btn ? String(btn.dataset.variantId || '') : (card ? String(card.dataset.deliveryVariantId || '') : '');
    if (!variantId) return;

    if (this.selectedDelivery && String(this.selectedDelivery.variantId) === variantId) {
      this.deliverySelect.value = '';
    } else {
      this.deliverySelect.value = variantId;
    }
    this.deliverySelect.dispatchEvent(new Event('change', { bubbles: true }));
  }

  updateDeliveryCardState() {
    const card = this.deliveryCard || (this.deliveryRoot ? this.deliveryRoot.querySelector('[data-delivery-card]') : null);
    const btn = this.deliveryToggleBtn || (this.deliveryRoot ? this.deliveryRoot.querySelector('[data-delivery-toggle-btn]') : null);
    if (!card || !btn) return;

    const btnText = btn.querySelector('.custom-delivery-btn-text');
    const isSelected = Boolean(this.selectedDelivery && this.selectedDelivery.variantId);

    card.classList.toggle('is-active', isSelected);
    card.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
    btn.classList.toggle('is-active', isSelected);
    btn.setAttribute('aria-pressed', isSelected ? 'true' : 'false');

    if (btnText) {
      btnText.textContent = isSelected ? 'Remove' : 'Add';
    }
  }

  handleDeliverySelectionChange() {
    if (!this.deliverySelect) return;

    const selectedOption = this.deliverySelect.options[this.deliverySelect.selectedIndex];
    const variantId = this.deliverySelect.value ? String(this.deliverySelect.value) : '';

    this.logBundleDebug('delivery-dropdown-change', {
      rawValue: this.deliverySelect.value,
      selectedIndex: this.deliverySelect.selectedIndex,
      selectedText: selectedOption ? String(selectedOption.textContent || '').trim() : ''
    });

    if (!variantId || !selectedOption) {
      this.selectedDelivery = null;
      this.setDeliverySelectionError(false);
      this.logBundleDebug('delivery-selection-cleared', {
        selectedDelivery: this.selectedDelivery
      });
      this.updateDeliveryCardState();
      this.updateDeliveryLineItemProperties();
      this.updatePrice();
      this.updateButtonState();
      this.updateSummaryChips();
      return;
    }

    this.selectedDelivery = {
      variantId,
      title: String(selectedOption.dataset.deliveryVariantTitle || selectedOption.textContent || '').trim(),
      price: Number(selectedOption.dataset.deliveryVariantPrice || 0)
    };

    this.logBundleDebug('delivery-selection-updated', {
      selectedDelivery: this.selectedDelivery,
      productId: this.deliveryRoot ? String(this.deliveryRoot.dataset.deliveryProductId || '') : '',
      productTitle: this.deliveryRoot ? String(this.deliveryRoot.dataset.deliveryProductTitle || '') : ''
    });

    this.updateDeliveryCardState();
    this.setDeliverySelectionError(false);
    this.updateDeliveryLineItemProperties();
    this.updatePrice();
    this.updateButtonState();
    this.updateSummaryChips();
  }

  handleStorageSelectionClick(event) {
    const variantOption = event.target.closest('[data-storage-variant-option]');
    if (variantOption && this.storageProductsRoot.contains(variantOption)) {
      if (variantOption.disabled) return;

      const productId = String(variantOption.dataset.storageProductId || '');
      const card = variantOption.closest('[data-storage-product-card]');
      const cardTitle = card ? String(card.dataset.storageProductTitle || '') : '';
      const varTitle = String(variantOption.dataset.storageVariantTitle || '');
      const title = (cardTitle && varTitle && varTitle !== 'Default Title')
        ? `${cardTitle} - ${varTitle}`
        : (varTitle && varTitle !== 'Default Title' ? varTitle : cardTitle);

      this.activeStorageProductId = productId;
      this.selectedStorage = {
        productId,
        variantId: String(variantOption.dataset.storageVariantId || ''),
        title: title || cardTitle,
        price: Number(variantOption.dataset.storageVariantPrice || 0)
      };

      this.setStorageSelectionError(false);
      this.updateStorageSelectionState();
      this.updatePrice();
      this.updateButtonState();
      this.updateSummaryChips();
      return;
    }

    const productTrigger = event.target.closest('[data-storage-product-trigger]');
    if (!productTrigger || !this.storageProductsRoot.contains(productTrigger)) return;

    const card = productTrigger.closest('[data-storage-product-card]');
    if (!card) return;

    const productId = String(card.dataset.storageProductId || '');
    const hasVariants = String(card.dataset.storageHasVariants || '') === 'true';
    this.activeStorageProductId = productId;

    if (hasVariants) {
      const isSameProductSelected = this.selectedStorage && String(this.selectedStorage.productId) === productId;
      if (!isSameProductSelected) {
        const variantButtons = [...card.querySelectorAll('[data-storage-variant-option]')];
        const firstAvail = variantButtons.find((btn) => !btn.disabled);
        if (firstAvail) {
          const varTitle = String(firstAvail.dataset.storageVariantTitle || '');
          const cardTitle = String(card.dataset.storageProductTitle || '');
          const title = (cardTitle && varTitle && varTitle !== 'Default Title')
            ? `${cardTitle} - ${varTitle}`
            : (varTitle && varTitle !== 'Default Title' ? varTitle : cardTitle);
          this.selectedStorage = {
            productId,
            variantId: String(firstAvail.dataset.storageVariantId || ''),
            title: title || cardTitle,
            price: Number(firstAvail.dataset.storageVariantPrice || 0)
          };
          this.setStorageSelectionError(false);
        } else {
          this.selectedStorage = null;
        }
      }
    } else {
      this.selectedStorage = {
        productId,
        variantId: String(card.dataset.storageDefaultVariantId || ''),
        title: String(card.dataset.storageProductTitle || ''),
        price: Number(card.dataset.storageDefaultPrice || 0)
      };
      this.setStorageSelectionError(false);
    }

    this.updateStorageSelectionState();
    this.updatePrice();
    this.updateButtonState();
    this.updateSummaryChips();
  }

  updateStorageSelectionState() {
    if (!this.storageProductCards.length) return;

    this.storageProductCards.forEach((card) => {
      const productId = String(card.dataset.storageProductId || '');
      const isActiveProduct = Boolean(this.activeStorageProductId && this.activeStorageProductId === productId);
      const variantsWrap = card.querySelector('[data-storage-variants]');
      const trigger = card.querySelector('[data-storage-product-trigger]');
      const hasVariants = String(card.dataset.storageHasVariants || '') === 'true';

      card.classList.toggle('is-active', isActiveProduct);
      if (trigger) {
        trigger.setAttribute('aria-pressed', String(isActiveProduct));
      }

      if (variantsWrap) {
        variantsWrap.hidden = !isActiveProduct;
      }

      if (hasVariants) {
        const selectedVariantId = this.selectedStorage && String(this.selectedStorage.productId) === productId
          ? String(this.selectedStorage.variantId || '')
          : '';

        card.querySelectorAll('[data-storage-variant-option]').forEach((button) => {
          const isActiveVariant = Boolean(selectedVariantId) && String(button.dataset.storageVariantId || '') === selectedVariantId;
          button.classList.toggle('is-active', isActiveVariant);
          button.setAttribute('aria-pressed', String(isActiveVariant));
        });
      }
    });
  }

  setStorageSelectionError(showError) {
    if (!this.storageSelectionError) return;
    this.storageSelectionError.hidden = !showError;
  }

  setHeadboardSelectionError(showError) {
    if (!this.headboardSelectionError) return;
    this.headboardSelectionError.hidden = !showError;
  }

  setDeliverySelectionError(showError) {
    if (!this.deliverySelectionError) return;
    this.deliverySelectionError.hidden = !showError;
  }

  hasValidStorageSelection() {
    if (!this.storageProductCards.length) return true;
    if (!this.selectedStorage) return false;

    const selectedCard = this.storageProductCards.find(
      (card) => String(card.dataset.storageProductId || '') === String(this.selectedStorage.productId || '')
    );
    if (!selectedCard) return false;

    const hasVariants = String(selectedCard.dataset.storageHasVariants || '') === 'true';
    if (!hasVariants) {
      return Boolean(this.selectedStorage.variantId);
    }

    return Boolean(this.selectedStorage.variantId);
  }

  hasValidHeadboardSelection() {
    if (!this.headboardCards.length && !this.headboardSelect) return true;
    return Boolean(this.selectedHeadboard && this.selectedHeadboard.variantId);
  }

  hasValidDeliverySelection() {
    return true;
  }

  getSelectedStoragePrice() {
    if (!this.hasValidStorageSelection()) return 0;
    return Number(this.selectedStorage && this.selectedStorage.price ? this.selectedStorage.price : 0);
  }

  getSelectedHeadboardPrice() {
    if (!this.hasValidHeadboardSelection()) return 0;
    return Number(this.selectedHeadboard && this.selectedHeadboard.price ? this.selectedHeadboard.price : 0);
  }

  getSelectedDeliveryPrice() {
    if (!this.hasValidDeliverySelection()) return 0;
    return Number(this.selectedDelivery && this.selectedDelivery.price ? this.selectedDelivery.price : 0);
  }

  // Nested cart line functionality start
  getSelectedStorageCartItem(parentVariantId) {
    if (!this.hasValidStorageSelection()) return null;
    if (!this.storageProductCards.length) return null;
    if (!this.selectedStorage) return null;

    return {
      id: Number(this.selectedStorage.variantId),
      quantity: 1,
      parent_id: parentVariantId,
      properties: { _child: '1' }
    };
  }
  // Nested cart line functionality end

  // Nested cart line functionality start
  getSelectedHeadboardCartItem(parentVariantId) {
    if (!this.hasValidHeadboardSelection()) return null;
    if (!this.headboardSelect) return null;
    if (!this.selectedHeadboard) return null;

    return {
      id: Number(this.selectedHeadboard.variantId),
      quantity: 1,
      parent_id: parentVariantId,
      properties: { _child: '1' }
    };
  }
  // Nested cart line functionality end

  // Nested cart line functionality start
  getSelectedDeliveryCartItem(parentVariantId) {
    if (!this.hasValidDeliverySelection()) return null;
    if (!this.deliverySelect) return null;
    if (!this.selectedDelivery) return null;

    return {
      id: Number(this.selectedDelivery.variantId),
      quantity: 1,
      parent_id: parentVariantId,
      properties: { _child: '1' }
    };
  }
  // Nested cart line functionality end

  // Nested cart line functionality start

  syncChildSelections() {
    if (!this.childProductsRoot) {
      this.selectedChildItems = [];
      return;
    }

    const items = [...this.childProductsRoot.querySelectorAll('[data-child-item]')];
    this.selectedChildItems = items
      .filter((item) => {
        const checkbox = item.querySelector('[data-child-checkbox]');
        return checkbox && checkbox.checked && !checkbox.disabled;
      })
      .map((item) => ({
        variantId: String(item.dataset.childVariantId || ''),
        title: String(item.dataset.childProductTitle || ''),
        price: Number(item.dataset.childVariantPrice || 0),
        available: item.dataset.childAvailable === 'true'
      }))
      .filter((item) => item.variantId && item.available);
  }

  getSelectedChildItems() {
    this.syncChildSelections();
    return this.selectedChildItems.slice();
  }

  getSelectedChildTotalPrice() {
    if (!this.childProductsRoot) return 0;
    this.syncChildSelections();
    return this.selectedChildItems.reduce((sum, item) => sum + Number(item.price || 0), 0);
  }

  async addChildNestedLines(parentKey, childItems) {
    if (!parentKey || !childItems || !childItems.length) return;

    const endpoint = window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add.js';
    const payload = {
      items: childItems
        .filter((child) => child.variantId && child.available)
        .map((child) => ({
          id: Number(child.variantId),
          quantity: 1,
          parent_id: parentKey
        }))
    };

    if (!payload.items.length) return;

    this.logBundleDebug('nested-children-payload', payload);

    try {
      const response = await fetch(endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify(payload)
      });

      if (!response.ok) {
        let errorBody = null;
        try { errorBody = await response.json(); } catch (e) { errorBody = null; }
        this.logBundleDebug('nested-children-failed', { status: response.status, body: errorBody });
        return;
      }

      const childResponse = await response.json();
      this.logBundleDebug('nested-children-added', childResponse);

      if (this.childProductsRoot) {
        this.childProductsRoot.querySelectorAll('[data-child-checkbox]').forEach((cb) => {
          cb.checked = false;
        });
        this.selectedChildItems = [];
      }
    } catch (error) {
      this.logBundleDebug('nested-children-error', { message: error && error.message ? error.message : 'unknown' });
    }
  }

  // Nested cart line functionality end

  // Child drawer restrictions start

  initChildDrawerRestrictions() {
    const sidebar = document.querySelector('#halo-cart-sidebar');
    if (!sidebar) return;

    const self = this;

    // Re-apply restrictions whenever the sidebar's DOM is mutated (items re-rendered).
    // Debounced so rapid DOM mutations only trigger one fetch.
    new MutationObserver(() => {
      clearTimeout(self._childRestrictTimer);
      self._childRestrictTimer = setTimeout(() => self.applyChildLineRestrictions(), 200);
    }).observe(sidebar, { childList: true, subtree: true });

    // Also re-apply whenever the cart drawer is opened (body gains cart-sidebar-show).
    new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        if (mutation.attributeName === 'class' && document.body.classList.contains('cart-sidebar-show')) {
          clearTimeout(self._childRestrictTimer);
          self._childRestrictTimer = setTimeout(() => self.applyChildLineRestrictions(), 100);
          break;
        }
      }
    }).observe(document.body, { attributes: true, attributeFilter: ['class'] });
  }

  applyChildLineRestrictions() {
    fetch('/cart.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    })
      .then((r) => (r.ok ? r.json() : null))
      .then((cart) => {
        if (!cart || !Array.isArray(cart.items)) return;

        const childKeys = new Set(
          cart.items
            .filter((item) => (item.parent_id != null && item.parent_id !== 0) || (item.properties && item.properties._child === '1'))
            .map((item) => String(item.key))
        );

        this.markChildLinesInDrawer(childKeys, cart.items);
      })
      .catch(() => {});
  }

  markChildLinesInDrawer(childKeys, cartItems = []) {
    const sidebar = document.querySelector('#halo-cart-sidebar');
    if (!sidebar) return;

    sidebar.querySelectorAll('.mpc-child-line').forEach((el) => {
      el.classList.remove('mpc-child-line', 'mpc-child-line--at-min');
    });

    if (!childKeys.size) return;

    // Map parentVariantId (number) → parent cart item key string
    const parentKeyByVariantId = new Map();
    cartItems.forEach((item) => {
      if (item.parent_id == null || item.parent_id === 0) {
        parentKeyByVariantId.set(Number(item.id), String(item.key));
      }
    });

    // parentKey → ordered array of child elements for DOM reordering
    const parentKeyToChildEls = new Map();

    childKeys.forEach((key) => {
      const el = this.findDrawerLineElement(key, sidebar);
      if (!el) return;

      el.classList.add('mpc-child-line');

      // Set at-min state from current quantity value
      const qtyInput = el.querySelector('input[data-cart-quantity]') || el.querySelector('input[name="quantity"]');
      if (qtyInput && (parseInt(qtyInput.value, 10) || 1) <= 1) {
        el.classList.add('mpc-child-line--at-min');
      }

      // Register child for DOM reordering under its parent
      const cartItem = cartItems.find((i) => String(i.key) === key);
      if (cartItem && cartItem.parent_id) {
        const parentKey = parentKeyByVariantId.get(Number(cartItem.parent_id));
        if (parentKey) {
          if (!parentKeyToChildEls.has(parentKey)) parentKeyToChildEls.set(parentKey, []);
          parentKeyToChildEls.get(parentKey).push(el);
        }
      }
    });

    // DOM reorder: move child elements to immediately follow their parent
    parentKeyToChildEls.forEach((childEls, parentKey) => {
      const parentEl = this.findDrawerLineElement(parentKey, sidebar);
      if (!parentEl || !parentEl.parentNode) return;
      let insertAfter = parentEl;
      childEls.forEach((childEl) => {
        if (childEl.parentNode === parentEl.parentNode && childEl !== insertAfter.nextSibling) {
          parentEl.parentNode.insertBefore(childEl, insertAfter.nextSibling);
        }
        insertAfter = childEl;
      });
    });

    this.attachChildQtyListeners(sidebar);
  }

  attachChildQtyListeners(sidebar) {
    if (sidebar._mpcQtyListenerAttached) return;
    sidebar._mpcQtyListenerAttached = true;

    // Capture-phase click: intercept minus button before UpdateQuantity handler fires
    sidebar.addEventListener('click', (e) => {
      const btn = e.target.closest('.minus.btn-quantity, [data-minus-quantity-cart]');
      if (!btn) return;
      const lineEl = btn.closest('.mpc-child-line');
      if (!lineEl) return;
      const input = lineEl.querySelector('input[data-cart-quantity]') || lineEl.querySelector('input[name="quantity"]');
      if (input && (parseInt(input.value, 10) || 1) <= 1) {
        e.stopImmediatePropagation();
        e.preventDefault();
      }
    }, true);

    // Capture-phase change: enforce min=1 and sync at-min class before Halo's handler
    sidebar.addEventListener('change', (e) => {
      const input = e.target;
      if (!input.matches('[data-cart-quantity], input[name="quantity"]')) return;
      const lineEl = input.closest('.mpc-child-line');
      if (!lineEl) return;
      if ((parseInt(input.value, 10) || 0) < 1) input.value = '1';
      lineEl.classList.toggle('mpc-child-line--at-min', (parseInt(input.value, 10) || 1) <= 1);
    }, true);
  }

  findDrawerLineElement(key, root) {
    // 1. Direct data-attribute match (Dawn, Impulse, and many custom themes)
    for (const attr of ['data-key', 'data-cart-item-key', 'data-line-item-key', 'data-item-key']) {
      const el = root.querySelector(`[${attr}="${key}"]`);
      if (el) return el;
    }

    // 2. Halo theme: quantity input carries data-line="{{ item.key }}"
    const haloInput = root.querySelector(`input[data-line="${key}"]`);
    if (haloInput) {
      return haloInput.closest('[data-item-row], li, tr, [class*="item"], [data-cart-item]') || haloInput.parentElement;
    }

    // 3. Standard Shopify name="updates[KEY]" quantity input
    const updatesInput = root.querySelector(`input[name="updates[${key}]"]`);
    if (updatesInput) {
      return updatesInput.closest('li, tr, [class*="item"], [data-cart-item]') || updatesInput.parentElement;
    }

    // 4. Any element whose href contains the line key
    const withHref = root.querySelector(`[href*="${key}"]`);
    if (withHref) {
      return withHref.closest('li, tr, [class*="item"], [data-cart-item]') || withHref.parentElement;
    }

    return null;
  }

  // Child drawer restrictions end
}

const mountMainProductCustom = (root = document) => {
  root.querySelectorAll('[data-main-product-custom]').forEach((section) => {
    if (!section.dataset.customMounted) {
      section.dataset.customMounted = 'true';
      new MainProductCustom(section);
    }
  });
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    mountMainProductCustom(document);
  });
} else {
  mountMainProductCustom(document);
}

document.addEventListener('shopify:section:load', (event) => {
  if (!event.target) return;
  mountMainProductCustom(event.target);
});

// Child drawer restrictions moved to theme.js to execute globally on all pages.

